window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    var params = {
      $container: this.$container,
      product: options.product,
      singleOptionSelector: options.singleOptionSelector,
      originalSelectorId: options.originalSelectorId,
      currentVariant: this.currentVariant,
    };

    this.swatches = new slate.Swatches(params);

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      //Integration with Discount Ninja
      document.dispatchEvent(new CustomEvent('la:dn:variant:changed'), [this.currentVariant.id]);
      
      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();
/**
 * Swatches Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the swatches inputs in any `cart/add` forms that may
 * exist.
 *
 * @namespace swatches
 */

slate.Swatches = (function() {

  var selectors = {
    swatches: '[data-swatch]',
    swatchOptions: '[data-swatch-option]',
  };

  /**
   * Swatches constructor
   *
   * @param {object} options - Settings from `variants.js`
   */
  function Swatches(params) {
    this.$container = params.$container;
    this.product = params.product;
    this.currentVariant = params.currentVariant;
    this.singleOptionSelector = params.singleOptionSelector;
    this.originalSelectorId = params.originalSelectorId;
    this.variants = this.product.variants;
    this.options = this.product.options;
    this.swatches = $(selectors.swatches);
    this.swatchOptions = this.swatches.find(selectors.swatchOptions);
    this.colorOptionIndex = this.getOptionIndex('color');

    this.hideSwatchesSelects();
    this.defineAvailableColors();
    this.updateVariantMax(this.currentVariant);

    let self = this;
    if (this.colorOptionIndex >= 0) {
      let $filterableSwatches = this.swatches.filter(function(index) {
        return $(self.swatches[index]).data('option-index') != self.colorOptionIndex;
      });
      this.showAvailableOptions(this, $filterableSwatches, this.currentVariant.options[this.colorOptionIndex]);
    } else {
      this.showAvailableOptions(this, this.swatches);
    }

    function findAncestor(el, sel) {
      while (
        (el = el.parentElement) &&
        !(el.matches || el.matchesSelector).call(el, sel)
      );
      return el;
    }

    $(this.swatchOptions, this.$container).on('change', function(){
      let evt = $(this);
      const parent = findAncestor($(this)[0], '.swatch')
      parent.querySelector('.select-validation-error')?.remove()
  
      self.switchSwatches.bind(self)(evt);
    });

    /*$(this.swatchOptions, this.$container).parent().hover(function() {
      let $option = $(this).find(selectors.swatchOptions);

      if ($option.data('swatch-option') == self.colorOptionIndex) {
        let $swatchHolder = $option.closest(selectors.swatches);
        $swatchHolder.find('.header > span').text($swatchHolder.data('swatch')+': '+$option.val());
      }
    }, function() {
      let $option = $(this).find(selectors.swatchOptions);

      if ($option.data('swatch-option') == self.colorOptionIndex && self.currentVariant !== undefined) {
        let $swatchHolder = $option.closest(selectors.swatches);
        $swatchHolder.find('.header > span').text($swatchHolder.data('swatch')+': '+self.currentVariant.options[self.colorOptionIndex]);
      }
    });*/

  }

  Swatches.prototype = $.extend({}, Swatches.prototype, {

    hideSwatchesSelects: function() {
      let self = this;

      this.swatches.each(function() {
        let $swatch = $(this);
        $(self.singleOptionSelector).addClass('jcf-ignore').eq(self.getOptionIndex($swatch.data('swatch'))).parent().hide();
      });
    },

    /**
     * Show only av
     *
     * @param {object} variant - Currently selected variant
     */
    defineAvailableColors: function() {
      let self = this;

      if (this.colorOptionIndex >= 0) {
        $.each(this.variants, function(i, variant) {
          if (variant.available) {
            let $option = self.swatchOptions.filter('#swatch-'+self.colorOptionIndex+'-'+variant.options[self.colorOptionIndex].toLowerCase());
            self.makeSwatchOptionAvailable($option);
          }
        });
      }
    },

    makeSwatchOptionAvailable: function($option) {
      $option.parent().addClass('available').removeClass('soldout');

      return $option;
    },

    makeSwatchOptionUnavailable: function($option, allowProcessing) {
      if (allowProcessing) {
        $option.prop('checked', false);
      }
      $option.parent().addClass('soldout').removeClass('available');

      return $option;
    },

    getOptionIndex: function(optionName) {
      return this.options.map(v => v.toLowerCase()).indexOf(optionName.toLowerCase());
    },

    getVariantLabels: function(variant) {
      const badgesLists = document.querySelectorAll('.product-badges');
      if(!badgesLists) {
        return;
      }

      badgesLists.forEach((badgesList) => {
        const variantId = badgesList.getAttribute('data-variant-id');

        badgesList.classList.add('hide');
        if(variantId == variant.id) {
          badgesList.classList.remove('hide');
        }
      })
    },

    updateVariantMax: function(variant) {
      const variantQtyMax = jQuery('[data-product-select]').find('[data-variant-qty]:selected').attr('data-variant-qty');
      const variantPolicy = jQuery('[data-product-select]').find('[data-variant-policy]:selected').attr('data-variant-policy');
      const productQty = document.querySelector('[data-product-quantity]');
      const productQtyVal = productQty.value;

      if ( variantPolicy == 'continue' ) {
        jQuery(productQty).removeAttr('max');
      } else {
        jQuery(productQty).attr('max', variantQtyMax);
        if (productQtyVal > variantQtyMax) {
          jQuery(productQty).attr('value', variantQtyMax);
          jQuery(productQty).val(variantQtyMax);
        }
        if (window.jcf !== undefined) {
          setTimeout(jcf.destroyAll(), 100);
          jcf.setOptions('Select', {
            wrapNative: false,
            wrapNativeOnMobile: false
          });
          setTimeout(jcf.replaceAll(), 100);
        }
      }
    },

    switchSwatches: function($option) {
      let self = this;
      let swatchIndex = $option.data('swatch-option');
      let $optionSelector = $(this.singleOptionSelector).eq(swatchIndex);
      let optionVal = $option.val();

      if ($optionSelector.val() !== optionVal) {
        let $otherSwatches = this.swatches.filter(function(index) {
          return $(self.swatches[index]).data('option-index') != swatchIndex;
        });
        if (swatchIndex != this.colorOptionIndex) {
          let $swatchesWithoutColor = this.swatches.filter(function(index) {
            return $(self.swatches[index]).data('option-index') != self.colorOptionIndex;
          });
          $otherSwatches = $otherSwatches.filter(value => !$swatchesWithoutColor.has(value));
        }

        if ($otherSwatches.length > 0) {
          this.showAvailableOptions(self, $otherSwatches, optionVal, 'switch');
        }

        $optionSelector.val(optionVal);
      }

      $(this.singleOptionSelector).first().trigger('change');
      this.currentVariant = self.variants.filter(function(v) {return v.id == $(self.originalSelectorId).val();})[0];
    },

    showAvailableOptions: function(self, $swatches, optionVal = '', type = 'load') {
      let allowProccessing = self.isVariantSet();
      self.makeSwatchOptionUnavailable($swatches.find(selectors.swatchOptions), allowProccessing);

      let hasChecked = false;

      $.each(self.variants, function(i, variant) {
        if (self.colorOptionIndex >= 0) {
          if (((variant.options[self.colorOptionIndex] == optionVal) || (optionVal.length === 0 && variant.options[0] == self.currentVariant.options[0])) && variant.available) {
            $.each($swatches, function(i, swatch) {
              let $swatch = $(swatch);
              let currentSwatchIndex = $swatch.data('option-index');
              let $optionSelector = $(self.singleOptionSelector).eq(currentSwatchIndex);
              let $option = $('[data-value="'+variant.options[currentSwatchIndex]+'"]').find(selectors.swatchOptions).first();

              self.makeSwatchOptionAvailable($option);

              if (type == 'load') {

                if (self.currentVariant.options[currentSwatchIndex] == variant.options[currentSwatchIndex]) {
                  //$option.prop('checked', true);
                  $optionSelector.val(variant.options[currentSwatchIndex]);
                }
              } else {
                if (allowProccessing) {
                  if (self.currentVariant) {
                    if (self.currentVariant.options[currentSwatchIndex] == variant.options[currentSwatchIndex]) {
                      $option.prop('checked', true);
                      $optionSelector.val(variant.options[currentSwatchIndex]);
                    } else if (!hasChecked) {
                      $option.prop('checked', true);
                      $optionSelector.val(variant.options[currentSwatchIndex]);
                    }
                  } else if (!hasChecked) {
                    $option.prop('checked', true);
                    $optionSelector.val(variant.options[currentSwatchIndex]);
                  }
                  hasChecked = true;
                }
              }

            });

          }
        } else {
          $.each($swatches, function(i, swatch) {
            let $swatch = $(swatch);
            let currentSwatchIndex = $swatch.data('option-index');
            //let $optionSelector = $(self.singleOptionSelector).eq(currentSwatchIndex);
            let $option = $('[data-value="'+variant.options[currentSwatchIndex]+'"]').find(selectors.swatchOptions).first();

            self.makeSwatchOptionAvailable($option);
          });
        }
      });
    },

    isVariantSet: function () {
      let allSwatchesHasValues = true;

      $(selectors.swatches).each(function () {
        let $swatchOptions = $(this).find(selectors.swatchOptions+':checked');

        if(!$swatchOptions.length) {
          allSwatchesHasValues = false;
        }
      });

      return allSwatchesHasValues;
    },

  });

  return Swatches;
})();

/*================ Sections ================*/
/**
 * Header Section Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Header section.
 *
   * @namespace header
 */

theme.Header = (function() {

  var selectors = {
    headerContainer: '.site-header',
    navigation: '#nav',
    navigationWithDropDowns: '.main-nav__item--has-dropdown',
    navigationWithSubmenu: '.main-nav__sublink--with-submenu',
    mobileNavOpener: '[data-nav-opener]',
    navBackButton: '[data-nav-back]',
    searchBarOpener: '[data-search-bar-opener]',
    searchBar: '[data-search-bar]'
  };

  var config = {
    stickyHeaderCssClass: 'sticky-header',
    transparentHeaderClass: 'transparent-header',
    mobileNavOpenedCssClass: 'header-nav-opened',
    searchBarOpenedCssClass: 'search-bar-opened',
    activeDropdownCssClass: 'active-dropdown',
    mobileNavBreakpoint: 1200
  }

  /**
   * Hedaer section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Header(container) {
    let self = this;
    this.$container = $(container);
    this.navigation = $(selectors.navigation);
    this.navItemsWithDropDown = $(selectors.navigationWithDropDowns, this.navigation);
    this.navigationWithSubmenu = $(selectors.navigationWithSubmenu, this.navigation);
    this.mobileNavOpener = $(selectors.mobileNavOpener, this.$container);
    this.navBackButton = $(selectors.navBackButton, this.$container);
    this.searchBarOpener = $(selectors.searchBarOpener, this.$container);
    this.searchBar = $(selectors.searchBar, this.$container);

    this.namespace = '.header';

    this.header = document.querySelector(selectors.headerContainer);
    // Get the offset position of the header
    this.sticky = this.header.offsetTop;

    this.initStickyHeader.bind(this)();

    window.onscroll = this.initStickyHeader.bind(this);

    this.navItemsWithDropDown.on('mouseover' + this.namespace, this.navigationOnHover.bind(this));
    // this.navItemsWithDropDown.on('mouseleave' + this.namespace, this.navigationOnLeave.bind(this));

    this.mobileNavOpener.on('click' + this.namespace, this.openMobileNav.bind(this));
    this.navItemsWithDropDown.children('a').on('click' + this.namespace, this.navigationOnClick.bind(this));
    this.navigationWithSubmenu.on('click' + this.namespace, this.subnavigationOnClick.bind(this));
    this.navBackButton.on('click' + this.namespace, this.navigationBackOnClick.bind(this));
    this.searchBarOpener.on('click' + this.namespace, this.searchBarOpenerOnClick.bind(this));

    this.headerIsTransparent = $('body').hasClass(config.transparentHeaderClass);

    $(document).click((e) => {
      if  (!$(e.target).closest(selectors.mobileNavOpener).length) {
        if (!$(e.target).closest(selectors.navigation).length && $('body').hasClass(config.mobileNavOpenedCssClass)) {
          $('body').removeClass(config.mobileNavOpenedCssClass);
        }
      }
      if  (!$(e.target).closest(selectors.searchBarOpener).length) {
        if (!$(e.target).closest(selectors.searchBar).length && $('body').hasClass(config.searchBarOpenedCssClass)) {
          $('body').removeClass(config.searchBarOpenedCssClass);

          if (self.headerIsTransparent) {
            $('body').addClass(config.transparentHeaderClass);
          }
        }
      }
    });
  }

  Header.prototype = $.extend({}, Header.prototype, {

    initStickyHeader: function() {
      // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
      if (window.pageYOffset > this.sticky) {
        this.stickyHeaderOn();
      } else {
        this.stickyHeaderOff();
      }
    },

    navigationOnHover: function() {
      if ($(window).width() >= config.mobileNavBreakpoint) {
        this.stickyHeaderOn();
      }
    },

    navigationOnLeave: function() {
      if ($(window).width() >= config.mobileNavBreakpoint) {
        this.stickyHeaderOff();
      }
    },

    navigationOnClick: function (e) {
      if ($(window).width() < config.mobileNavBreakpoint) {
        e.preventDefault();
        $(e.target).closest(this.navItemsWithDropDown).addClass(config.activeDropdownCssClass);
      }
    },

    navigationBackOnClick: function (e) {
      if ($(window).width() < config.mobileNavBreakpoint) {
        e.preventDefault();
        $(e.target).closest(this.navItemsWithDropDown).removeClass(config.activeDropdownCssClass);
      }
    },

    subnavigationOnClick: function (e) {
      if ($(window).width() < config.mobileNavBreakpoint) {
        e.preventDefault();
        let $currentLink = $(e.target);
        let $submenu = $currentLink.next('ul');

        if ($submenu.is(':hidden')) {
          $currentLink.addClass('opened');
          $submenu.slideDown();
        } else {
          $currentLink.removeClass('opened');
          $submenu.slideUp();
        }
      }
    },

    searchBarOpenerOnClick: function (e) {
      e.preventDefault();
      if (!$('body').hasClass(config.searchBarOpenedCssClass)) {
        $('[name="q"]', selectors.searchBar).focus();
      }
      $('body').toggleClass(config.searchBarOpenedCssClass);

      if (this.headerIsTransparent) {
        $('body').toggleClass(config.transparentHeaderClass);
      }
    },

    stickyHeaderOn: function () {
      $('body').addClass(config.stickyHeaderCssClass);
    },

    stickyHeaderOff: function () {
      $('body').removeClass(config.stickyHeaderCssClass);
    },

    openMobileNav: function (e) {
      e.preventDefault();

      if ($('body').hasClass(config.mobileNavOpenedCssClass)) {
        this.navItemsWithDropDown.removeClass(config.activeDropdownCssClass);
      }

      $('body').toggleClass(config.mobileNavOpenedCssClass);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Header;
})();

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productSlider: '[data-product-slider]',
    productThumbnails: '[data-product-thumbnails]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    upsellSection: '[data-upsell]',
    upsellDesktopContainer: '[data-upsell-desktop]',
    upsellMobileContainer: '[data-upsell-mobile]',
    inventory: '[data-inventory]',
    shippingDate: '[data-shipping-date]',
    preselectedMessage: '[data-preselected]',
    shippingDatesJson: '#variants_shipping_dates'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    var self = this;
    this.$container = $(container);
    this.$form = $(container).find('form');
    let mainForm = this.$form
    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.currentVariant   = this.variants.currentVariant;
    //const currentOptions  = this.getCurrentVariantOptions(this.currentVariant);
    this.$preselectedMessage = $(selectors.preselectedMessage, this.$container);
    this.$inventory = $(selectors.inventory, this.$container);
    this.$shippingDate = $(selectors.shippingDate, this.$container);
    this.$shippingDatesJson = JSON.parse($(selectors.shippingDatesJson, this.$container).html());

    // hide inventory and shipping date before sleecting swatches
    this.$inventory.addClass('hide');
    this.$shippingDate.hide();

    // gallery containers
    this.$slider = this.$container.find(selectors.productSlider);
    this.$thumbnails = this.$container.find(selectors.productThumbnails);

    // main product slider
    if(this.$slider.length){
      this.$slider.slick({
        prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous"></button>',
        nextArrow: '<button class="slick-arrow slick-next" aria-label="Next"></button>',
        asNavFor: selectors.productThumbnails,
        infinite: true,
        lazyLoad: 'progressive',
        responsive: [{
          breakpoint: 767,
          settings: {
            rows: 0,
            dots: true
          }
        }]
      }).on('beforeChange', function (e, slick, currentSlide, nextSlide) {
        slick.$slider.addClass('slick-busy');
        const CurrentSlideDom= $(slick.$slides.get(currentSlide));
        
        if(CurrentSlideDom && CurrentSlideDom[0].querySelector('.is-video')){
          const isVideo = CurrentSlideDom[0].querySelector('video')
          const isIframe = CurrentSlideDom[0].querySelector('iframe')
          
          if(isIframe){
            isIframe.src = CurrentSlideDom[0].querySelector('.is-video').dataset.iframeStop
          }

          if(isVideo){
            isVideo.pause()
            isVideo.currentTime = 0;
          }

        }
      }).on('afterChange', function (e, slick, currentSlide) {
        slick.$slider.removeClass('slick-busy');
        const CurrentSlideDom= $(slick.$slides.get(currentSlide));
        
        if(CurrentSlideDom && CurrentSlideDom[0].querySelector('.is-video')){
          const isVideo = CurrentSlideDom[0].querySelector('video')
          const isIframe = CurrentSlideDom[0].querySelector('iframe')
          
          if(isIframe){
            isIframe.src = CurrentSlideDom[0].querySelector('.is-video').dataset.iframe
          }

          if(isVideo){
            console.log(isVideo)
            isVideo.play()
          }

        }
      });
    }

    this.$slider.slick("slickSetOption", "swipe", window.innerWidth < 1025);
    $(window).on('resize orientationchange', () => {
      self.$slider.slick("slickSetOption", "swipe", window.innerWidth < 1025);
      self.$slider.slick('resize');
      self.repositionUpsellSection();
    });

    // thumbnails slider
    if(this.$thumbnails.length){
      this.$thumbnails.on('init', function() {
        try {
          self.$thumbnails.slick("slickGoTo", 0, true);
        }
        catch(error) {
          setTimeout(function() {self.$thumbnails.trigger('init');}, 5);
          return;
        }

        self.updateProductSlider.bind(self)();
        self.$thumbnails.addClass('slick-loaded');
        self.$slider.addClass('slick-loaded');

        self.isFileExecutable($('[data-spin]', self.$slider).find('.Sirv').data('src').split('?')[0], function () {
          $('[data-spin]', self.$slider).each(function () {
            let index = $(this).closest('.slick-slide').data('slick-index');

            if (index >= 0) {
              self.$slider.slick('slickRemove', index);
              self.$thumbnails.slick('slickRemove', index);
            }
          });

          self.$thumbnails.slick('getSlick').$slides.each(function (index, slide) {
            slide.setAttribute('data-slick-index', index);
          });

          self.$slider.slick('getSlick').$slides.each(function (index, slide) {
            slide.setAttribute('data-slick-index', index);
          });
        });
      });
      this.$thumbnails.slick({
        slidesToShow: 6,
        prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous"></button>',
        nextArrow: '<button class="slick-arrow slick-next" aria-label="Next"></button>',
        asNavFor: selectors.productSlider,
        focusOnSelect: true,
        infinite: true,
        lazyLoad: 'ondemand',
        responsive: [{
          breakpoint: 1023,
          settings: {
            rows: 0,
            slidesToShow: 4
          }
        }]
      });
    }

    this.$thumbnails.slick("slickSetOption", "swipe", window.innerWidth < 1025);
    $(window).on('resize orientationchange', () => {
      self.$thumbnails.slick("slickSetOption", "swipe", window.innerWidth < 1025);
    });

    this.$container.on('variantChange' + this.namespace, this.updateProductSlider.bind(this));
    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantChange' + this.namespace, this.updateInventory.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    // disable button before select swatch
    // if (!this.$container.data('gift-card') && $('[name="id"]').prop("tagName") == 'SELECT') {
    //   $(selectors.addToCart, this.$container).prop('disabled', true);
    // }
    
    this.$form.on('submit', function(e){
      e.preventDefault()
     
      validateForm(e)
    })

    function validateForm(e){
      let allSelected = 1
      mainForm.find('.swatch').each(function(){
        if($(this).find('input[type=radio]:checked').length){
          allSelected = allSelected * 1
        }else{
          allSelected = allSelected * 0
          if($(this).find('.select-validation-error').length){
            return
          }else{
            let e = document.createElement('div');
            e.classList.add('select-validation-error')
            e.innerHTML = `Please select ${$(this).data('swatch')}`;
            $(this).append(e)
          }
        }
      })
      if(e && allSelected){
        e.currentTarget.submit()
      }
    }

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

    // Create "window.Shoppad.apps.infiniteoptions" object if it doesn't already exist
    "Shoppad.apps.infiniteoptions".split(".").reduce(function(o, x) { if (!o[x]) {o[x] ={};} return o[x] }, window);
    // Define beforeReady callback
    window.Shoppad.apps.infiniteoptions.beforeReady = function(subscribe) {
      subscribe('appLoad', function(event) {
        // init jcf
        jcf.setOptions('Select', {
          wrapNative: true,
          wrapNativeOnMobile: true
        });
        jcf.replaceAll('#infiniteoptions-container');
      });
      subscribe('fieldChange', function(event) {
        if(event.detail.value !== ''){
          const errorDiv = document.querySelector('#infiniteoptions-container .select-validation-error')
          if(errorDiv){
            errorDiv.remove()
          }
        }
      });
      subscribe('validationFail', function(event) {
        event.preventDefault();
        const errorDiv = document.querySelector('#infiniteoptions-container .select-validation-error')
        if(errorDiv){
          errorDiv.innerHTML = event.detail.error
        }else{
          let e = document.createElement('div');
          e.classList.add('select-validation-error')
          e.innerHTML = event.detail.error;
          document.querySelector('#infiniteoptions-container > div').append(e)
        }

        validateForm()
        
        
      });
    };

    self.repositionUpsellSection();
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (!this.$container.data('gift-card') ) {
        if (!slate.Swatches.prototype.isVariantSet()) {
          return;
        }
      }

      this.$preselectedMessage.remove();

      this.$shippingDate.text(theme.strings.shipsBy+' '+this.$shippingDatesJson["id"+variant.id]);

      if (this.$shippingDate.is(':hidden')) {
        this.$shippingDate.show();
      }

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      /*
      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }*/

if (variant.available) {
  $(selectors.addToCart, this.$container).prop('disabled', false);

  const $el = $(selectors.addToCartText, this.$container);

  // texti set et
  $el.html(theme.strings.addToCart);

  // svg varsa sil (duplicate olmasın)
  $el.find('svg.bi-bag-plus').remove();

  // sona svg ekle
  $el.append(` <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bag-plus" viewBox="0 0 16 16">
    <path fill-rule="evenodd" d="M8 7.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0v-1.5H6a.5.5 0 0 1 0-1h1.5V8a.5.5 0 0 1 .5-.5"></path>
    <path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1m3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"></path>
  </svg>`);

} else {
  $(selectors.addToCart, this.$container).prop('disabled', true);

  $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
}

    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
          .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with specified inventory status
     */

    // Ferkos product shipping and inventory logic
    
updateInventory: function (evt) {
  var variant = evt && evt.variant;
  var inventoryHolder = this.$inventory;

  if (!inventoryHolder || !inventoryHolder.length) {
    console.error('[FERKOS STOCK] data-inventory elementi bulunamadı.');
    return;
  }

  inventoryHolder = inventoryHolder.first();

  var shippingContainer = inventoryHolder.closest('.product-shipping__info2');

  if (!shippingContainer.length) {
    shippingContainer = $('.product-shipping__info2').first();
  }

  if (!shippingContainer.length) {
    console.error('[FERKOS STOCK] .product-shipping__info2 bulunamadı.');
    return;
  }

  var shippingHolder = shippingContainer.find('[data-shipping-date]').first();
  var variantId = variant ? String(variant.id) : '';
  var INVENTORY_THRESHOLD = 500;

  var isReadyToShip =
    shippingContainer.attr('data-ready-to-ship') === 'true';

  var defaultShipping = $.trim(
    shippingContainer.attr('data-default-shipping') || ''
  );

  var hasShipsByTag =
    shippingContainer.attr('data-has-shipsby-tag') === 'true' ||
    defaultShipping !== '';

  var shipsByLabel =
    shippingContainer.attr('data-ships-by-label') ||
    'Ships by';

  var currentDateString =
    shippingContainer.attr('data-current-date');


  function ensureShippingHolder() {
    if (shippingHolder.length) {
      return;
    }

    shippingHolder = $('<li>', {
      'data-shipping-date': '',
      'class': 'gosterkeee'
    });

    shippingContainer.append(shippingHolder);
  }


  function showMadeToOrder() {
    inventoryHolder
      .text('Made to Order')
      .removeClass('hide');

    if (inventoryHolder.get(0)) {
      inventoryHolder
        .get(0)
        .style
        .setProperty(
          'display',
          'block',
          'important'
        );
    }
  }


  function hideMadeToOrder() {
    inventoryHolder
      .text('Made to Order')
      .addClass('hide');

    if (inventoryHolder.get(0)) {
      inventoryHolder
        .get(0)
        .style
        .setProperty(
          'display',
          'none',
          'important'
        );
    }
  }


  function normalizeOrderDeadlineMessage(dateText) {
    var value = $.trim(
      String(dateText || '')
    );

    var parts;
    var normalized = [];
    var index;
    var part;

    if (!value) {
      return '';
    }

    value = value.replace(
      /^\s*Ships\s+by\s+/i,
      ''
    );

    parts = value.split(/\s+-\s+/);

    for (
      index = 0;
      index < parts.length;
      index++
    ) {
      part = $.trim(parts[index]);

      part = part.replace(
        /,\s*\d{4}\s*$/,
        ''
      );

      if (part) {
        normalized.push(part);
      }
    }

    return normalized.join(' - ');
  }


  function resolvedPromise(value) {
    var deferred = $.Deferred();

    deferred.resolve(value);

    return deferred.promise();
  }


  function setLineItemShippingDateProperty(dateText) {
    var value = $.trim(String(dateText || ''));
    var productForm = shippingContainer
      .closest('[data-section-type="product"], [data-product-section], .product-single, .product')
      .find('form[action*="/cart/add"]')
      .first();
    var propertyInput;

    if (!productForm.length) {
      productForm = $('form[action*="/cart/add"]').first();
    }

    if (!productForm.length) {
      console.error('[FERKOS SHIPPING] Ürün formu bulunamadı.');
      return;
    }

    propertyInput = productForm.find(
      'input[name="properties[_ferkos_shipping_date]"]'
    );

    if (!value) {
      propertyInput.remove();
      return;
    }

    value = value.replace(/^\s*Ships\s+by\s+/i, '');

    if (!propertyInput.length) {
      propertyInput = $('<input>', {
        type: 'hidden',
        name: 'properties[_ferkos_shipping_date]'
      }).appendTo(productForm);
    }

    propertyInput.val(value);
  }


  function saveOrderDeadlineCartAttribute(dateText) {
    var message =
      normalizeOrderDeadlineMessage(dateText);

    var shopRoot =
      (
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
      )
        ? window.Shopify.routes.root
        : '/';

    if (shopRoot.slice(-1) !== '/') {
      shopRoot += '/';
    }

    if (
      window.__FERKOS_SAVED_ORDER_DEADLINE_MESSAGE__ ===
      message
    ) {
      return resolvedPromise(message);
    }

    if (
      window.__FERKOS_PENDING_ORDER_DEADLINE_MESSAGE__ ===
        message &&
      window.__FERKOS_ORDER_DEADLINE_CART_REQUEST__ &&
      window.__FERKOS_ORDER_DEADLINE_CART_REQUEST__
        .readyState !== 4
    ) {
      return window
        .__FERKOS_ORDER_DEADLINE_CART_REQUEST__;
    }

    if (
      window.__FERKOS_ORDER_DEADLINE_CART_REQUEST__ &&
      window.__FERKOS_ORDER_DEADLINE_CART_REQUEST__
        .readyState !== 4
    ) {
      window
        .__FERKOS_ORDER_DEADLINE_CART_REQUEST__
        .abort();
    }

    window.__FERKOS_PENDING_ORDER_DEADLINE_MESSAGE__ =
      message;

    window.__FERKOS_ORDER_DEADLINE_CART_REQUEST__ =
      $.ajax({
        url:
          shopRoot +
          'cart/update.js',

        type: 'POST',

        dataType: 'json',

        contentType:
          'application/json; charset=utf-8',

        processData: false,

        cache: false,

        data: JSON.stringify({
          attributes: {
            orderDeadlineAppCartMessage:
              message
          }
        })
      })
        .done(function (cart) {
          window.__FERKOS_SAVED_ORDER_DEADLINE_MESSAGE__ =
            message;

          console.log(
            '[FERKOS SHIPPING] orderDeadlineAppCartMessage kaydedildi:',
            cart &&
            cart.attributes
              ? cart.attributes
                  .orderDeadlineAppCartMessage
              : message
          );
        })
        .fail(function (
          xhr,
          status,
          error
        ) {
          if (status === 'abort') {
            return;
          }

          console.error(
            '[FERKOS SHIPPING] orderDeadlineAppCartMessage kaydedilemedi:',
            error || status,
            xhr && xhr.responseText
              ? xhr.responseText
              : ''
          );
        })
        .always(function () {
          if (
            window.__FERKOS_PENDING_ORDER_DEADLINE_MESSAGE__ ===
            message
          ) {
            window.__FERKOS_PENDING_ORDER_DEADLINE_MESSAGE__ =
              null;
          }
        });

    return window
      .__FERKOS_ORDER_DEADLINE_CART_REQUEST__;
  }


  function showShippingDate(
    shippingType,
    shippingDateText
  ) {
    ensureShippingHolder();

    shippingHolder
      .attr(
        'data-shipping-type',
        shippingType
      )
      .removeAttr('aria-busy')
      .text(
        shipsByLabel +
        ' ' +
        shippingDateText
      )
      .removeClass('hide');

    if (shippingHolder.get(0)) {
      shippingHolder
        .get(0)
        .style
        .setProperty(
          'display',
          'block',
          'important'
        );
    }

    setLineItemShippingDateProperty(
      shippingDateText
    );

    saveOrderDeadlineCartAttribute(
      shippingDateText
    );
  }


  function hideShippingDate() {
    if (shippingHolder.length) {
      shippingHolder
        .attr(
          'data-shipping-type',
          'none'
        )
        .removeAttr('aria-busy')
        .text('')
        .addClass('hide');

      if (shippingHolder.get(0)) {
        shippingHolder
          .get(0)
          .style
          .setProperty(
            'display',
            'none',
            'important'
          );
      }
    }

    setLineItemShippingDateProperty('');

    saveOrderDeadlineCartAttribute('');
  }


  function showShippingLoading() {
    ensureShippingHolder();

    shippingHolder
      .attr(
        'data-shipping-type',
        'loading'
      )
      .attr(
        'aria-busy',
        'true'
      )
      .text('Loading shipping date...')
      .removeClass('hide');

    if (shippingHolder.get(0)) {
      shippingHolder
        .get(0)
        .style
        .setProperty(
          'display',
          'block',
          'important'
        );
    }
  }


  function showShippingFallback() {
    if (
      hasShipsByTag &&
      defaultShipping
    ) {
      showShippingDate(
        'shipsby-tag',
        defaultShipping
      );
    } else {
      hideShippingDate();
    }
  }


  function getVisibleShippingDateText() {
    var text;
    var escapedLabel;
    var labelPattern;

    if (!shippingHolder.length) {
      return '';
    }

    text = $.trim(
      shippingHolder.text() || ''
    );

    if (!text) {
      return '';
    }

    escapedLabel =
      String(shipsByLabel).replace(
        /[.*+?^${}()|[\]\\]/g,
        '\\$&'
      );

    labelPattern = new RegExp(
      '^\\s*' +
      escapedLabel +
      '\\s+',
      'i'
    );

    return $.trim(
      text.replace(
        labelPattern,
        ''
      )
    );
  }


  function getStoreDate(dateString) {
    var currentDate;
    var dateParts;

    if (!dateString) {
      currentDate = new Date();

      return new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate(),
        12,
        0,
        0
      );
    }

    dateParts =
      dateString.split('-');

    if (dateParts.length !== 3) {
      currentDate = new Date();

      return new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate(),
        12,
        0,
        0
      );
    }

    return new Date(
      parseInt(dateParts[0], 10),
      parseInt(dateParts[1], 10) - 1,
      parseInt(dateParts[2], 10),
      12,
      0,
      0
    );
  }


  function addBusinessDays(
    originalDate,
    numberOfDays
  ) {
    var date =
      new Date(
        originalDate.getTime()
      );

    var addedDays = 0;
    var dayOfWeek;

    while (
      addedDays < numberOfDays
    ) {
      date.setDate(
        date.getDate() + 1
      );

      dayOfWeek =
        date.getDay();

      if (
        dayOfWeek !== 0 &&
        dayOfWeek !== 6
      ) {
        addedDays++;
      }
    }

    return date;
  }


  function formatShippingDate(date) {
    var monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ];

    var day =
      date.getDate();

    if (day < 10) {
      day =
        '0' +
        day;
    }

    return (
      monthNames[
        date.getMonth()
      ] +
      ' ' +
      day +
      ', ' +
      date.getFullYear()
    );
  }


  function findOrderDeadlineInventory(
    payload,
    requestedVariantId
  ) {
    var variants;
    var index;
    var inventoryQuantity;

    if (
      !payload ||
      !requestedVariantId ||
      !payload.shopifyCachedProductData ||
      !payload.shopifyCachedProductData.variants
    ) {
      return null;
    }

    variants =
      payload
        .shopifyCachedProductData
        .variants;

    for (
      index = 0;
      index < variants.length;
      index++
    ) {
      if (
        String(variants[index].id) ===
        String(requestedVariantId)
      ) {
        inventoryQuantity =
          parseInt(
            variants[index].inventoryQuantity,
            10
          );

        return isNaN(
          inventoryQuantity
        )
          ? null
          : inventoryQuantity;
      }
    }

    return null;
  }


  function cacheOrderDeadlineInventories(
    payload
  ) {
    var variants;
    var index;
    var inventoryQuantity;
    var cacheKey =
      window.location.pathname;

    window.__FERKOS_ORDER_DEADLINE_INVENTORY_CACHE__ =
      window.__FERKOS_ORDER_DEADLINE_INVENTORY_CACHE__ ||
      {};

    window.__FERKOS_ORDER_DEADLINE_INVENTORY_CACHE__[
      cacheKey
    ] =
      window.__FERKOS_ORDER_DEADLINE_INVENTORY_CACHE__[
        cacheKey
      ] ||
      {};

    if (
      !payload ||
      !payload.shopifyCachedProductData ||
      !payload.shopifyCachedProductData.variants
    ) {
      return;
    }

    variants =
      payload
        .shopifyCachedProductData
        .variants;

    for (
      index = 0;
      index < variants.length;
      index++
    ) {
      inventoryQuantity =
        parseInt(
          variants[index].inventoryQuantity,
          10
        );

      if (!isNaN(inventoryQuantity)) {
        window
          .__FERKOS_ORDER_DEADLINE_INVENTORY_CACHE__[
            cacheKey
          ][
            String(variants[index].id)
          ] =
            inventoryQuantity;
      }
    }
  }


  function getCachedOrderDeadlineInventory(
    requestedVariantId
  ) {
    var cacheKey =
      window.location.pathname;

    var productCache =
      window.__FERKOS_ORDER_DEADLINE_INVENTORY_CACHE__ &&
      window.__FERKOS_ORDER_DEADLINE_INVENTORY_CACHE__[
        cacheKey
      ];

    if (
      !productCache ||
      !Object.prototype.hasOwnProperty.call(
        productCache,
        String(requestedVariantId)
      )
    ) {
      return null;
    }

    return productCache[
      String(requestedVariantId)
    ];
  }


  function findLatestOrderDeadlineUrl() {
    var entries;
    var entryIndex;
    var resourceUrl;

    if (
      !window.performance ||
      typeof window.performance
        .getEntriesByType !==
        'function'
    ) {
      return '';
    }

    entries =
      window.performance
        .getEntriesByType(
          'resource'
        );

    for (
      entryIndex =
        entries.length - 1;
      entryIndex >= 0;
      entryIndex--
    ) {
      resourceUrl =
        entries[entryIndex].name ||
        '';

      if (
        resourceUrl
          .toLowerCase()
          .indexOf(
            'shop.orderdeadline.com/app/frontend/api.php'
          ) !== -1
      ) {
        return resourceUrl;
      }
    }

    return '';
  }


  function waitForOrderDeadlineUrl() {
    var deferred =
      $.Deferred();

    var startedAt =
      new Date().getTime();

    var intervalId;


    function checkUrl() {
      var orderDeadlineUrl =
        findLatestOrderDeadlineUrl();

      if (orderDeadlineUrl) {
        window.clearInterval(
          intervalId
        );

        deferred.resolve(
          orderDeadlineUrl
        );

        return;
      }

      if (
        new Date().getTime() -
        startedAt >=
        10000
      ) {
        window.clearInterval(
          intervalId
        );

        deferred.reject(
          'Order Deadline network isteği bulunamadı.'
        );
      }
    }


    intervalId =
      window.setInterval(
        checkUrl,
        100
      );

    checkUrl();

    return deferred.promise();
  }


  function fetchOrderDeadlinePayload(
    requestedVariantId
  ) {
    var deferred =
      $.Deferred();

    var requestCacheKey =
      window.location.pathname;

    if (!requestedVariantId) {
      deferred.reject(
        'Order Deadline isteği için varyant ID bulunamadı.'
      );

      return deferred.promise();
    }

    window.__FERKOS_ORDER_DEADLINE_PENDING_REQUESTS__ =
      window.__FERKOS_ORDER_DEADLINE_PENDING_REQUESTS__ ||
      {};

    if (
      window.__FERKOS_ORDER_DEADLINE_PENDING_REQUESTS__[
        requestCacheKey
      ]
    ) {
      return window
        .__FERKOS_ORDER_DEADLINE_PENDING_REQUESTS__[
          requestCacheKey
        ];
    }

    window.__FERKOS_ORDER_DEADLINE_PENDING_REQUESTS__[
      requestCacheKey
    ] = deferred.promise();

    waitForOrderDeadlineUrl()
      .done(function (
        originalUrl
      ) {
        var uniqueValue =
          new Date().getTime() +
          '_' +
          Math.floor(
            Math.random() *
            1000000000
          );

        var callbackName =
          '__ferkosOrderDeadlineJsonp_' +
          uniqueValue.replace(
            /[^a-zA-Z0-9_]/g,
            '_'
          );

        var parsedUrl;
        var requestUrl;
        var scriptElement;
        var timeoutId;
        var completed = false;


        function cleanup() {
          if (timeoutId) {
            window.clearTimeout(
              timeoutId
            );
          }

          try {
            delete window[
              callbackName
            ];
          } catch (deleteError) {
            window[
              callbackName
            ] = undefined;
          }

          if (
            scriptElement &&
            scriptElement.parentNode
          ) {
            scriptElement
              .parentNode
              .removeChild(
                scriptElement
              );
          }
        }


        function rejectRequest(
          message
        ) {
          if (completed) {
            return;
          }

          completed = true;

          cleanup();

          deferred.reject(
            message
          );
        }


        try {
          parsedUrl =
            new URL(
              originalUrl,
              window.location.href
            );

          parsedUrl
            .searchParams
            .set(
              'callback',
              callbackName
            );

          parsedUrl
            .searchParams
            .set(
              'shopifyVariantId',
              String(
                requestedVariantId
              )
            );

          parsedUrl
            .searchParams
            .set(
              'getExtraData',
              '1'
            );

          parsedUrl
            .searchParams
            .set(
              '_',
              uniqueValue
            );

          parsedUrl
            .searchParams
            .set(
              'ferkos_inventory_refresh',
              uniqueValue
            );

          requestUrl =
            parsedUrl.toString();

        } catch (urlError) {
          rejectRequest(
            'Order Deadline URL parse edilemedi.'
          );

          return;
        }


        window[callbackName] =
          function (payload) {
            if (completed) {
              return;
            }

            completed = true;

            cleanup();

            cacheOrderDeadlineInventories(
              payload
            );

            deferred.resolve(
              payload
            );
          };


        scriptElement =
          document.createElement(
            'script'
          );

        scriptElement.async =
          true;

        scriptElement.src =
          requestUrl;

        scriptElement.onerror =
          function () {
            rejectRequest(
              'Order Deadline JSONP isteği başarısız oldu.'
            );
          };


        timeoutId =
          window.setTimeout(
            function () {
              rejectRequest(
                'Order Deadline JSONP isteği zaman aşımına uğradı.'
              );
            },
            10000
          );


        console.log(
          '[FERKOS STOCK] Order Deadline istek varyantı:',
          requestedVariantId
        );

        document.head.appendChild(
          scriptElement
        );
      })
      .fail(function (error) {
        deferred.reject(error);
      });

    deferred.always(function () {
      delete window
        .__FERKOS_ORDER_DEADLINE_PENDING_REQUESTS__[
          requestCacheKey
        ];
    });

    return deferred.promise();
  }


  function applyInventoryFlow(
    inventoryQuantity
  ) {
    var storeDate;
    var nextDayDateText;
    var sevenToTenDateText;
    var realStock;
    var hasRealStock;

    inventoryQuantity =
      parseInt(
        inventoryQuantity,
        10
      );

    if (
      isNaN(
        inventoryQuantity
      )
    ) {
      console.error(
        '[FERKOS STOCK] Geçersiz stok değeri:',
        inventoryQuantity
      );

      showShippingFallback();
      return;
    }

    storeDate =
      getStoreDate(
        currentDateString
      );

    nextDayDateText =
      formatShippingDate(
        addBusinessDays(
          storeDate,
          1
        )
      );

    sevenToTenDateText =
      formatShippingDate(
        addBusinessDays(
          storeDate,
          7
        )
      ) +
      ' - ' +
      formatShippingDate(
        addBusinessDays(
          storeDate,
          10
        )
      );

    realStock =
      Math.max(
        inventoryQuantity -
        INVENTORY_THRESHOLD,
        0
      );

    hasRealStock =
      inventoryQuantity >
      INVENTORY_THRESHOLD;

    inventoryHolder
      .attr(
        'data-order-deadline-stock',
        inventoryQuantity
      )
      .attr(
        'data-real-stock',
        realStock
      );


    if (!isReadyToShip) {
      showMadeToOrder();

      if (
        hasShipsByTag &&
        defaultShipping
      ) {
        showShippingDate(
          'shipsby-tag',
          defaultShipping
        );
      } else {
        hideShippingDate();
      }

      return;
    }


    if (hasRealStock) {
      hideMadeToOrder();

      showShippingDate(
        'next-day-date',
        nextDayDateText
      );

      return;
    }


    showMadeToOrder();


    if (
      hasShipsByTag &&
      defaultShipping
    ) {
      showShippingDate(
        'shipsby-tag',
        defaultShipping
      );

      return;
    }


    showShippingDate(
      'ships-7-10-business-days',
      sevenToTenDateText
    );
  }


  var isVariantSelected = true;

  if (
    window.slate &&
    slate.Swatches &&
    slate.Swatches.prototype &&
    typeof slate.Swatches
      .prototype
      .isVariantSet ===
      'function'
  ) {
    isVariantSelected =
      slate.Swatches
        .prototype
        .isVariantSet();
  }


  if (!isVariantSelected) {
    var initialShippingDate =
      getVisibleShippingDateText();

    if (initialShippingDate) {
      saveOrderDeadlineCartAttribute(
        initialShippingDate
      );
    }

    console.log(
      '[FERKOS STOCK] Varyant henüz seçilmedi. Liquid görünümü korunuyor.'
    );

    return;
  }


  if (
    !variant ||
    !variantId
  ) {
    console.error(
      '[FERKOS STOCK] evt.variant bulunamadı.',
      evt
    );

    return;
  }


  var requestNumber =
    parseInt(
      shippingContainer.attr(
        'data-inventory-request-number'
      ),
      10
    );

  if (isNaN(requestNumber)) {
    requestNumber = 0;
  }

  requestNumber++;

  shippingContainer.attr(
    'data-inventory-request-number',
    requestNumber
  );


  if (!isReadyToShip) {
    showMadeToOrder();

    if (
      hasShipsByTag &&
      defaultShipping
    ) {
      showShippingDate(
        'shipsby-tag',
        defaultShipping
      );
    } else {
      hideShippingDate();
    }

    return;
  }


  var cachedInventoryQuantity =
    getCachedOrderDeadlineInventory(
      variantId
    );

  if (cachedInventoryQuantity !== null) {
    console.log(
      '[FERKOS STOCK] Stok bellekten kullanıldı:',
      variantId,
      cachedInventoryQuantity
    );

    applyInventoryFlow(
      cachedInventoryQuantity
    );

    return;
  }


  showShippingLoading();


  fetchOrderDeadlinePayload(
    variantId
  )
    .done(function (payload) {
      var latestRequestNumber =
        parseInt(
          shippingContainer.attr(
            'data-inventory-request-number'
          ),
          10
        );

      var inventoryQuantity;

      if (
        latestRequestNumber !==
        requestNumber
      ) {
        return;
      }

      inventoryQuantity =
        getCachedOrderDeadlineInventory(
          variantId
        );

      if (inventoryQuantity === null) {
        inventoryQuantity =
          findOrderDeadlineInventory(
            payload,
            variantId
          );
      }

      if (
        inventoryQuantity === null
      ) {
        showShippingFallback();

        console.error(
          '[FERKOS STOCK] Order Deadline payload içinde varyant stoğu bulunamadı:',
          variantId,
          payload
        );

        return;
      }


      console.group(
        '[FERKOS STOCK] Order Deadline sonucu'
      );

      console.log(
        'VARYANT ID:',
        variantId
      );

      console.log(
        'PAYLOAD SEÇİLİ VARYANT:',
        payload &&
        payload.variantId
          ? payload.variantId
          : variantId
      );

      console.log(
        'ORDER DEADLINE HAM STOK:',
        inventoryQuantity
      );

      console.log(
        '500 SONRASI GERÇEK STOK:',
        Math.max(
          inventoryQuantity -
          INVENTORY_THRESHOLD,
          0
        )
      );

      console.log(
        '500 ÜZERİ Mİ:',
        inventoryQuantity >
        INVENTORY_THRESHOLD
      );

      console.groupEnd();


      applyInventoryFlow(
        inventoryQuantity
      );
    })
    .fail(function (error) {
      var latestRequestNumber =
        parseInt(
          shippingContainer.attr(
            'data-inventory-request-number'
          ),
          10
        );

      if (
        latestRequestNumber !==
        requestNumber
      ) {
        return;
      }

      showShippingFallback();

      console.error(
        '[FERKOS STOCK] Order Deadline stok bilgisi alınamadı:',
        error
      );
    });
},

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Updates the DOM with the specified slides
     */
    updateProductSlider: function(evt) {
      let variant = evt !== undefined ? evt.variant : this.currentVariant;
      let colorOptionIndex = this.productSingleObject.options.map(v => v.toLowerCase()).indexOf('color');
      //let color = variant.options[colorOptionIndex];

      /*this.$slider.slick('slickUnfilter');
      let slider_has_color = $('[data-color="' + color + '"]', self.$slider);
      this.$slider.slick('slickFilter', function () {
        if (slider_has_color === undefined || slider_has_color.length === 0) {
          return true;
        } else {
          return $('[data-color="' + color + '"]', this).length === 1;
        }
      });
      this.$slider.slick('resize');

      this.$thumbnails.slick('slickUnfilter');
      let thumbnails_has_color = $('[data-color="' + color + '"]', self.$thumbnails);
      if (thumbnails_has_color !== undefined && thumbnails_has_color.length !== 0) {
        this.$thumbnails.slick('slickFilter', function () {
          return $('[data-color="' + color + '"]', this).length === 1;
        });
      }
      this.$thumbnails.slick('resize'); */

      if (variant.featured_media !== undefined) {
        let $slide = $('[data-media-id="product-' + variant.featured_media.id + '"]').closest('.slick-slide');
        if (this.$slider.hasClass('slick-busy')) {
          var self = this;
          setTimeout(function () {
            if (!$slide.hasClass('slick-active')) {
              let slideIndex = $slide.data('slick-index')
              self.$slider.slick('slickGoTo', slideIndex);
              self.$thumbnails.slick('slickGoTo', slideIndex);
            }
          }, 300);
        } else {
          if (!$slide.hasClass('slick-active')) {
            let slideIndex = $slide.data('slick-index')
            this.$slider.slick('slickGoTo', slideIndex);
            this.$thumbnails.slick('slickGoTo', slideIndex);
          }
        }
      }

      var index = 0;
      $.each(this.$thumbnails.find('.slick-slide').not(".slick-cloned"), function (t, v) {
        $(v).attr("data-slick-index", index);
        index++;
      });
    },

    /**
     * Change upsell section position for mobile/desktop devices
     */
    repositionUpsellSection: function () {
      let upsellSection = $(selectors.upsellSection).detach();
      let upsellDesktopContainer = $(selectors.upsellDesktopContainer);
      let upsellMobileContainer = $(selectors.upsellMobileContainer);

      if (window.innerWidth < 1200) {
        upsellMobileContainer.append(upsellSection);
      } else {
        upsellDesktopContainer.append(upsellSection);
      }
    },

    isFileExecutable: function (src, callback) {
      $.get(src).fail(function () {
        callback();
      });
    },


  /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();
/*================ Sections ================*/
/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace cart
 */

theme.Cart = (function() {

  var selectors = {
    giftWrap: '[data-gift-wrapper]',
    deliveryWithSignature: '[data-with-signature]',
    cartTotals: '[data-cart-totals]',
    lineItemQty: '[data-line-item-qty]',
    updateCartButton: '[data-update-btn]',
    submitCartButton: '[data-submit-btn]',
    confirmCheckbox: '[data-confirmation]',
    removeItemLink: '[data-remove-cart-item]',
  };

  /**
   * Cart section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Cart(container) {
    var self = this;
    this.namespace = '.cart';

    this.$container = $(container);
    this.$giftWrapToggler = $(selectors.giftWrap, this.$container);
    this.$delveryWithSignatureToggler = $(selectors.deliveryWithSignature, this.$container);
    this.$cartTotals = $(selectors.cartTotals, this.$container);
    this.$lineItemQtyInput = $(selectors.lineItemQty, this.$container);
    this.$confirmCheckbox = $(selectors.confirmCheckbox, this.$container);
    this.$submitCartButton = $(selectors.submitCartButton, this.$container);

    this.$giftWrapToggler.on('change'+this.namespace, this.toggleGiftWrapOption.bind(this));
    this.$delveryWithSignatureToggler.on('change'+this.namespace, this.toggleSignatureOption.bind(this));
    this.$lineItemQtyInput.on('change'+this.namespace, this.onLineItemQuantityChanged.bind(this));
    this.$submitCartButton.on('click'+this.namespace, this.cartSubmitValidation.bind(this));

    if (self.$giftWrapToggler.is(':checked') || self.$delveryWithSignatureToggler.is(':checked')) {
      self.getCart(function (cart) {
        if (cart.item_count == 1) {
          if (self.$giftWrapToggler.is(':checked')) {
            self.updateItemQty(self.$giftWrapToggler.data('gift-wrapper'), 0, true);
          } else {
            self.updateItemQty(self.$delveryWithSignatureToggler.data('with-signature'), 0, true);
          }
        } else if (cart.item_count == 2 && self.$giftWrapToggler.is(':checked') && self.$delveryWithSignatureToggler.is(':checked')) {
          self.updateItemQty(self.$giftWrapToggler.data('gift-wrapper'), 0, true);
          self.updateItemQty(self.$delveryWithSignatureToggler.data('with-signature'), 0, true);
        }
      });
    }
  }

  Cart.prototype = $.extend({}, Cart.prototype, {

    /**
     * Retrieve Cart data
     */
    getCart: function(callback) {
      $.getJSON('/cart.js', function (cart) {
        if (typeof callback === 'function') {
          callback(cart);
        }
      });
    },

    /**
     * Add item to cart
     */
    addItemToCart: function (id, properties = {}, reload = false) {
      var self = this;
      
      $.post('/cart/add.js', {
        items: [
          {
            quantity: 1,
            id: id,
            properties: properties
          }
        ]
      }, function() {
        if (reload) {
          document.location.reload();
        } else {
          self.getCart(self.updateCartData.bind(self));
        }
      }, 'json');
    },

    /**
     * Update cart item quantity
     */
    updateItemQty: function (id, qty, reload = false) {
      var self = this;

      $.post('/cart/change.js', {
        id: id,
        quantity: qty,
      }, function() {
        if (reload) {
          document.location.reload();
        } else {
          self.getCart(self.updateCartData.bind(self));
        }
      }, 'json');
    },

    /**
     * Event callback for Gift Wrap toggler
     */
    toggleGiftWrapOption: function (e) {
      let $toggler = $(e.target);
      $toggler.prop('disabled', true).parent().addClass('disabled');
      $(selectors.removeItemLink, this.$container).addClass('disabled');
      this.$lineItemQtyInput.parent().addClass('jcf-disabled');

      if ($toggler.is(':checked')) {
        this.addItemToCart($toggler.data('gift-wrapper'), {'_gift_wrap': true}, true);
      } else {
        this.updateItemQty($toggler.data('gift-wrapper'), 0, true);
      }
    },

    /**
     * Event callback for Signature toggler
     */
    toggleSignatureOption: function (e) {
      let $toggler = $(e.target);
      $toggler.prop('disabled', true).parent().addClass('disabled');
      $(selectors.removeItemLink, this.$container).addClass('disabled');
      this.$lineItemQtyInput.parent().addClass('jcf-disabled');

      if ($toggler.is(':checked')) {
        this.addItemToCart($toggler.data('with-signature'), {'_delivery_with_signature': true}, true);
      } else {
        this.updateItemQty($toggler.data('with-signature'), 0, true);
      }
    },

    /**
     * Event callback for line item quantity changed
     */
    onLineItemQuantityChanged: function() {
      $(selectors.updateCartButton, this.$container).click();
    },

    /**
     * Event callback for cart submit validation
     */
    cartSubmitValidation: function (e) {
      if (this.$confirmCheckbox.length && !this.$confirmCheckbox.is(':checked')) {
        e.preventDefault();
        let errorClass = 'error';

        if (!this.$confirmCheckbox.parent().hasClass(errorClass)) {
          this.$confirmCheckbox.parent().addClass(errorClass);
          alert('Please check and click the delivery date information');
        }
      }
    },

    /**
     * Update total price html and remove items link url
     */
    updateCartData(cart) {
      this.$cartTotals.html(slate.Currency.formatMoney(cart.total_price));

      let giftWrapIndex = -1;

      cart.items.forEach((item, index) => {
        $(selectors.removeItemLink, '[data-key="'+item.key+'"]').attr('href', '/cart/change?line='+(index+1)+'&amp;quantity=0')
        if (item.properties._gift_wrap !== undefined) {
          giftWrapIndex = index;
        }
      });

      if (giftWrapIndex >= 0) {
        let qtyInput = '<input type="hidden" name="updates[]" value="1" data-gift-wrap-qty>';
        $('[data-key]', this.$container).eq(giftWrapIndex+1).before(qtyInput);
      } else {
        $('[data-gift-wrap-qty]').remove();
      }

      this.$giftWrapToggler.prop('disabled', false).parent().removeClass('disabled');
      this.$delveryWithSignatureToggler.prop('disabled', false).parent().removeClass('disabled');
      $(selectors.removeItemLink, this.$container).removeClass('disabled');
      this.$lineItemQtyInput.parent().removeClass('jcf-disabled');
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Cart;
})();
/**
 * Footer Section Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Footer section.
 *
   * @namespace footer
 */

theme.Footer = (function() {

  var selectors = {
    footerOpenCloseOpener: '[data-open-close-opener]',
    footerOpenCloseSlide: '[data-open-close-slide]'
  };

  var config = {
    mobileNavBreakpoint: 1024
  };

  /**
   * Footer section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Footer(container) {
    this.$container = $(container);
    this.footerOpenCloseOpener = $(selectors.footerOpenCloseOpener, this.$container);

    this.namespace = '.footer';

    this.footerOpenCloseOpener.on('click' + this.namespace, this.openClose.bind(this));
  }

  Footer.prototype = $.extend({}, Footer.prototype, {

    openClose: function (e) {
      if ($(window).width() < config.mobileNavBreakpoint) {
        e.preventDefault();

        let $currentOpener = $(e.target);

        let $slide = $currentOpener.next(selectors.footerOpenCloseSlide);

        if ($slide.is(':hidden')) {
          $currentOpener.addClass('opened');
          $slide.slideDown();
        } else {
          $currentOpener.removeClass('opened');
          $slide.slideUp();
        }
      }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Footer;
})();


/*================ Plugins ================*/
/*!
 * JavaScript Custom Forms
 *
 * Copyright 2014-2015 PSD2HTML - http://psd2html.com/jcf
 * Released under the MIT license (LICENSE.txt)
 *
 * Version: 1.1.3
 */
;(function(root, factory) {

  'use strict';
  if (typeof define === 'function' && define.amd) {
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    module.exports = factory(require('jquery'));
  } else {
    root.jcf = factory(jQuery);
  }
}(this, function($) {

  'use strict';

  // define version
  var version = '1.1.3';

  // private variables
  var customInstances = [];

  // default global options
  var commonOptions = {
    optionsKey: 'jcf',
    dataKey: 'jcf-instance',
    rtlClass: 'jcf-rtl',
    focusClass: 'jcf-focus',
    pressedClass: 'jcf-pressed',
    disabledClass: 'jcf-disabled',
    hiddenClass: 'jcf-hidden',
    resetAppearanceClass: 'jcf-reset-appearance',
    unselectableClass: 'jcf-unselectable'
  };

  // detect device type
  var isTouchDevice = ('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch,
      isWinPhoneDevice = /Windows Phone/.test(navigator.userAgent);
  commonOptions.isMobileDevice = !!(isTouchDevice || isWinPhoneDevice);

  var isIOS = /(iPad|iPhone).*OS ([0-9_]*) .*/.exec(navigator.userAgent);
  if(isIOS) isIOS = parseFloat(isIOS[2].replace(/_/g, '.'));
  commonOptions.ios = isIOS;

  // create global stylesheet if custom forms are used
  var createStyleSheet = function() {
    var styleTag = $('<style>').appendTo('head'),
        styleSheet = styleTag.prop('sheet') || styleTag.prop('styleSheet');

    // crossbrowser style handling
    var addCSSRule = function(selector, rules, index) {
      if (styleSheet.insertRule) {
        styleSheet.insertRule(selector + '{' + rules + '}', index);
      } else {
        styleSheet.addRule(selector, rules, index);
      }
    };

    // add special rules
    addCSSRule('.' + commonOptions.hiddenClass, 'position:absolute !important;left:-9999px !important;height:1px !important;width:1px !important;margin:0 !important;border-width:0 !important;-webkit-appearance:none;-moz-appearance:none;appearance:none');
    addCSSRule('.' + commonOptions.rtlClass + ' .' + commonOptions.hiddenClass, 'right:-9999px !important; left: auto !important');
    addCSSRule('.' + commonOptions.unselectableClass, '-webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; -webkit-tap-highlight-color: rgba(0,0,0,0);');
    addCSSRule('.' + commonOptions.resetAppearanceClass, 'background: none; border: none; -webkit-appearance: none; appearance: none; opacity: 0; filter: alpha(opacity=0);');

    // detect rtl pages
    var html = $('html'), body = $('body');
    if (html.css('direction') === 'rtl' || body.css('direction') === 'rtl') {
      html.addClass(commonOptions.rtlClass);
    }

    // handle form reset event
    html.on('reset', function() {
      setTimeout(function() {
        api.refreshAll();
      }, 0);
    });

    // mark stylesheet as created
    commonOptions.styleSheetCreated = true;
  };

  // simplified pointer events handler
  (function() {
    var pointerEventsSupported = navigator.pointerEnabled || navigator.msPointerEnabled,
        touchEventsSupported = ('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch,
        eventList, eventMap = {}, eventPrefix = 'jcf-';

    // detect events to attach
    if (pointerEventsSupported) {
      eventList = {
        pointerover: navigator.pointerEnabled ? 'pointerover' : 'MSPointerOver',
        pointerdown: navigator.pointerEnabled ? 'pointerdown' : 'MSPointerDown',
        pointermove: navigator.pointerEnabled ? 'pointermove' : 'MSPointerMove',
        pointerup: navigator.pointerEnabled ? 'pointerup' : 'MSPointerUp'
      };
    } else {
      eventList = {
        pointerover: 'mouseover',
        pointerdown: 'mousedown' + (touchEventsSupported ? ' touchstart' : ''),
        pointermove: 'mousemove' + (touchEventsSupported ? ' touchmove' : ''),
        pointerup: 'mouseup' + (touchEventsSupported ? ' touchend' : '')
      };
    }

    // create event map
    $.each(eventList, function(targetEventName, fakeEventList) {
      $.each(fakeEventList.split(' '), function(index, fakeEventName) {
        eventMap[fakeEventName] = targetEventName;
      });
    });

    // jQuery event hooks
    $.each(eventList, function(eventName, eventHandlers) {
      eventHandlers = eventHandlers.split(' ');
      $.event.special[eventPrefix + eventName] = {
        setup: function() {
          var self = this;
          $.each(eventHandlers, function(index, fallbackEvent) {
            if (self.addEventListener) self.addEventListener(fallbackEvent, fixEvent, false);
            else self['on' + fallbackEvent] = fixEvent;
          });
        },
        teardown: function() {
          var self = this;
          $.each(eventHandlers, function(index, fallbackEvent) {
            if (self.addEventListener) self.removeEventListener(fallbackEvent, fixEvent, false);
            else self['on' + fallbackEvent] = null;
          });
        }
      };
    });

    // check that mouse event are not simulated by mobile browsers
    var lastTouch = null;
    var mouseEventSimulated = function(e) {
      var dx = Math.abs(e.pageX - lastTouch.x),
          dy = Math.abs(e.pageY - lastTouch.y),
          rangeDistance = 25;

      if (dx <= rangeDistance && dy <= rangeDistance) {
        return true;
      }
    };

    // normalize event
    var fixEvent = function(e) {
      var origEvent = e || window.event,
          touchEventData = null,
          targetEventName = eventMap[origEvent.type];

      e = $.event.fix(origEvent);
      e.type = eventPrefix + targetEventName;

      if (origEvent.pointerType) {
        switch (origEvent.pointerType) {
          case 2: e.pointerType = 'touch'; break;
          case 3: e.pointerType = 'pen'; break;
          case 4: e.pointerType = 'mouse'; break;
          default: e.pointerType = origEvent.pointerType;
        }
      } else {
        e.pointerType = origEvent.type.substr(0, 5); // "mouse" or "touch" word length
      }

      if (!e.pageX && !e.pageY) {
        touchEventData = origEvent.changedTouches ? origEvent.changedTouches[0] : origEvent;
        e.pageX = touchEventData.pageX;
        e.pageY = touchEventData.pageY;
      }

      if (origEvent.type === 'touchend') {
        lastTouch = { x: e.pageX, y: e.pageY };
      }
      if (e.pointerType === 'mouse' && lastTouch && mouseEventSimulated(e)) {
        return;
      } else {
        return ($.event.dispatch || $.event.handle).call(this, e);
      }
    };
  }());

  // custom mousewheel/trackpad handler
  (function() {
    var wheelEvents = ('onwheel' in document || document.documentMode >= 9 ? 'wheel' : 'mousewheel DOMMouseScroll').split(' '),
        shimEventName = 'jcf-mousewheel';

    $.event.special[shimEventName] = {
      setup: function() {
        var self = this;
        $.each(wheelEvents, function(index, fallbackEvent) {
          if (self.addEventListener) self.addEventListener(fallbackEvent, fixEvent, false);
          else self['on' + fallbackEvent] = fixEvent;
        });
      },
      teardown: function() {
        var self = this;
        $.each(wheelEvents, function(index, fallbackEvent) {
          if (self.addEventListener) self.removeEventListener(fallbackEvent, fixEvent, false);
          else self['on' + fallbackEvent] = null;
        });
      }
    };

    var fixEvent = function(e) {
      var origEvent = e || window.event;
      e = $.event.fix(origEvent);
      e.type = shimEventName;

      // old wheel events handler
      if ('detail'      in origEvent) { e.deltaY = -origEvent.detail;      }
      if ('wheelDelta'  in origEvent) { e.deltaY = -origEvent.wheelDelta;  }
      if ('wheelDeltaY' in origEvent) { e.deltaY = -origEvent.wheelDeltaY; }
      if ('wheelDeltaX' in origEvent) { e.deltaX = -origEvent.wheelDeltaX; }

      // modern wheel event handler
      if ('deltaY' in origEvent) {
        e.deltaY = origEvent.deltaY;
      }
      if ('deltaX' in origEvent) {
        e.deltaX = origEvent.deltaX;
      }

      // handle deltaMode for mouse wheel
      e.delta = e.deltaY || e.deltaX;
      if (origEvent.deltaMode === 1) {
        var lineHeight = 16;
        e.delta *= lineHeight;
        e.deltaY *= lineHeight;
        e.deltaX *= lineHeight;
      }

      return ($.event.dispatch || $.event.handle).call(this, e);
    };
  }());

  // extra module methods
  var moduleMixin = {
    // provide function for firing native events
    fireNativeEvent: function(elements, eventName) {
      $(elements).each(function() {
        var element = this, eventObject;
        if (element.dispatchEvent) {
          eventObject = document.createEvent('HTMLEvents');
          eventObject.initEvent(eventName, true, true);
          element.dispatchEvent(eventObject);
        } else if (document.createEventObject) {
          eventObject = document.createEventObject();
          eventObject.target = element;
          element.fireEvent('on' + eventName, eventObject);
        }
      });
    },
    // bind event handlers for module instance (functions beggining with "on")
    bindHandlers: function() {
      var self = this;
      $.each(self, function(propName, propValue) {
        if (propName.indexOf('on') === 0 && $.isFunction(propValue)) {
          // dont use $.proxy here because it doesn't create unique handler
          self[propName] = function() {
            return propValue.apply(self, arguments);
          };
        }
      });
    }
  };

  // public API
  var api = {
    version: version,
    modules: {},
    getOptions: function() {
      return $.extend({}, commonOptions);
    },
    setOptions: function(moduleName, moduleOptions) {
      if (arguments.length > 1) {
        // set module options
        if (this.modules[moduleName]) {
          $.extend(this.modules[moduleName].prototype.options, moduleOptions);
        }
      } else {
        // set common options
        $.extend(commonOptions, moduleName);
      }
    },
    addModule: function(proto) {
      // add module to list
      var Module = function(options) {
        // save instance to collection
        if (!options.element.data(commonOptions.dataKey)) {
          options.element.data(commonOptions.dataKey, this);
        }
        customInstances.push(this);

        // save options
        this.options = $.extend({}, commonOptions, this.options, getInlineOptions(options.element), options);

        // bind event handlers to instance
        this.bindHandlers();

        // call constructor
        this.init.apply(this, arguments);
      };

      // parse options from HTML attribute
      var getInlineOptions = function(element) {
        var dataOptions = element.data(commonOptions.optionsKey),
            attrOptions = element.attr(commonOptions.optionsKey);

        if (dataOptions) {
          return dataOptions;
        } else if (attrOptions) {
          try {
            return $.parseJSON(attrOptions);
          } catch (e) {
            // ignore invalid attributes
          }
        }
      };

      // set proto as prototype for new module
      Module.prototype = proto;

      // add mixin methods to module proto
      $.extend(proto, moduleMixin);
      if (proto.plugins) {
        $.each(proto.plugins, function(pluginName, plugin) {
          $.extend(plugin.prototype, moduleMixin);
        });
      }

      // override destroy method
      var originalDestroy = Module.prototype.destroy;
      Module.prototype.destroy = function() {
        this.options.element.removeData(this.options.dataKey);

        for (var i = customInstances.length - 1; i >= 0; i--) {
          if (customInstances[i] === this) {
            customInstances.splice(i, 1);
            break;
          }
        }

        if (originalDestroy) {
          originalDestroy.apply(this, arguments);
        }
      };

      // save module to list
      this.modules[proto.name] = Module;
    },
    getInstance: function(element) {
      return $(element).data(commonOptions.dataKey);
    },
    replace: function(elements, moduleName, customOptions) {
      var self = this,
          instance;

      if (!commonOptions.styleSheetCreated) {
        createStyleSheet();
      }

      $(elements).each(function() {
        var moduleOptions,
            element = $(this);

        instance = element.data(commonOptions.dataKey);
        if (instance) {
          instance.refresh();
        } else {
          if (!moduleName) {
            $.each(self.modules, function(currentModuleName, module) {
              if (module.prototype.matchElement.call(module.prototype, element)) {
                moduleName = currentModuleName;
                return false;
              }
            });
          }
          if (moduleName) {
            moduleOptions = $.extend({ element: element }, customOptions);
            instance = new self.modules[moduleName](moduleOptions);
          }
        }
      });
      return instance;
    },
    refresh: function(elements) {
      $(elements).each(function() {
        var instance = $(this).data(commonOptions.dataKey);
        if (instance) {
          instance.refresh();
        }
      });
    },
    destroy: function(elements) {
      $(elements).each(function() {
        var instance = $(this).data(commonOptions.dataKey);
        if (instance) {
          instance.destroy();
        }
      });
    },
    replaceAll: function(context) {
      var self = this;
      $.each(this.modules, function(moduleName, module) {
        $(module.prototype.selector, context).each(function() {
          if (this.className.indexOf('jcf-ignore') < 0) {
            self.replace(this, moduleName);
          }
        });
      });
    },
    refreshAll: function(context) {
      if (context) {
        $.each(this.modules, function(moduleName, module) {
          $(module.prototype.selector, context).each(function() {
            var instance = $(this).data(commonOptions.dataKey);
            if (instance) {
              instance.refresh();
            }
          });
        });
      } else {
        for (var i = customInstances.length - 1; i >= 0; i--) {
          customInstances[i].refresh();
        }
      }
    },
    destroyAll: function(context) {
      if (context) {
        $.each(this.modules, function(moduleName, module) {
          $(module.prototype.selector, context).each(function(index, element) {
            var instance = $(element).data(commonOptions.dataKey);
            if (instance) {
              instance.destroy();
            }
          });
        });
      } else {
        while (customInstances.length) {
          customInstances[0].destroy();
        }
      }
    }
  };

  // always export API to the global window object
  window.jcf = api;

  return api;
}));
/*!
 * JavaScript Custom Forms : Select Module
 *
 * Copyright 2014-2015 PSD2HTML - http://psd2html.com/jcf
 * Released under the MIT license (LICENSE.txt)
 *
 * Version: 1.1.3
 */
;(function($, window) {

  'use strict';

  jcf.addModule({
    name: 'Select',
    selector: 'select:not(.no-js)',
    options: {
      element: null,
      multipleCompactStyle: false
    },
    plugins: {
      ListBox: ListBox,
      ComboBox: ComboBox,
      SelectList: SelectList
    },
    matchElement: function(element) {
      return element.is('select');
    },
    init: function() {
      this.element = $(this.options.element);
      this.createInstance();
    },
    isListBox: function() {
      return this.element.is('[size]:not([jcf-size]), [multiple]');
    },
    createInstance: function() {
      if (this.instance) {
        this.instance.destroy();
      }
      if (this.isListBox() && !this.options.multipleCompactStyle) {
        this.instance = new ListBox(this.options);
      } else {
        this.instance = new ComboBox(this.options);
      }
    },
    refresh: function() {
      var typeMismatch = (this.isListBox() && this.instance instanceof ComboBox) ||
          (!this.isListBox() && this.instance instanceof ListBox);

      if (typeMismatch) {
        this.createInstance();
      } else {
        this.instance.refresh();
      }
    },
    destroy: function() {
      this.instance.destroy();
    }
  });

  // combobox module
  function ComboBox(options) {
    this.options = $.extend({
      wrapNative: true,
      wrapNativeOnMobile: true,
      fakeDropInBody: true,
      useCustomScroll: true,
      flipDropToFit: true,
      maxVisibleItems: 10,
      fakeAreaStructure: '<span class="jcf-select"><span class="jcf-select-text"></span><span class="jcf-select-opener"></span></span>',
      fakeDropStructure: '<div class="jcf-select-drop"><div class="jcf-select-drop-content"></div></div>',
      optionClassPrefix: 'jcf-option-',
      selectClassPrefix: 'jcf-select-',
      dropContentSelector: '.jcf-select-drop-content',
      selectTextSelector: '.jcf-select-text',
      dropActiveClass: 'jcf-drop-active',
      flipDropClass: 'jcf-drop-flipped'
    }, options);
    this.init();
  }
  $.extend(ComboBox.prototype, {
    init: function() {
      this.initStructure();
      this.bindHandlers();
      this.attachEvents();
      this.refresh();
    },
    initStructure: function() {
      // prepare structure
      this.win = $(window);
      this.doc = $(document);
      this.realElement = $(this.options.element);
      this.fakeElement = $(this.options.fakeAreaStructure).insertAfter(this.realElement);
      this.selectTextContainer = this.fakeElement.find(this.options.selectTextSelector);
      this.selectText = $('<span></span>').appendTo(this.selectTextContainer);
      makeUnselectable(this.fakeElement);

      // copy classes from original select
      this.fakeElement.addClass(getPrefixedClasses(this.realElement.prop('className'), this.options.selectClassPrefix));

      // handle compact multiple style
      if (this.realElement.prop('multiple')) {
        this.fakeElement.addClass('jcf-compact-multiple');
      }

      // detect device type and dropdown behavior
      if (this.options.isMobileDevice && this.options.wrapNativeOnMobile && !this.options.wrapNative) {
        this.options.wrapNative = true;
      }

      if (this.options.wrapNative) {
        // wrap native select inside fake block
        this.realElement.prependTo(this.fakeElement).css({
          position: 'absolute',
          height: '100%',
          width: '100%'
        }).addClass(this.options.resetAppearanceClass);
      } else {
        // just hide native select
        this.realElement.addClass(this.options.hiddenClass);
        this.fakeElement.attr('title', this.realElement.attr('title'));
        this.fakeDropTarget = this.options.fakeDropInBody ? $('body') : this.fakeElement;
      }
    },
    attachEvents: function() {
      // delayed refresh handler
      var self = this;
      this.delayedRefresh = function() {
        setTimeout(function() {
          self.refresh();
          if (self.list) {
            self.list.refresh();
            self.list.scrollToActiveOption();
          }
        }, 1);
      };

      // native dropdown event handlers
      if (this.options.wrapNative) {
        this.realElement.on({
          focus: this.onFocus,
          change: this.onChange,
          click: this.onChange,
          keydown: this.onChange
        });
      } else {
        // custom dropdown event handlers
        this.realElement.on({
          focus: this.onFocus,
          change: this.onChange,
          keydown: this.onKeyDown
        });
        this.fakeElement.on({
          'jcf-pointerdown': this.onSelectAreaPress
        });
      }
    },
    onKeyDown: function(e) {
      if (e.which === 13) {
        this.toggleDropdown();
      } else if (this.dropActive) {
        this.delayedRefresh();
      }
    },
    onChange: function() {
      this.refresh();
    },
    onFocus: function() {
      if (!this.pressedFlag || !this.focusedFlag) {
        this.fakeElement.addClass(this.options.focusClass);
        this.realElement.on('blur', this.onBlur);
        this.toggleListMode(true);
        this.focusedFlag = true;
      }
    },
    onBlur: function() {
      if (!this.pressedFlag) {
        this.fakeElement.removeClass(this.options.focusClass);
        this.realElement.off('blur', this.onBlur);
        this.toggleListMode(false);
        this.focusedFlag = false;
      }
    },
    onResize: function() {
      if (this.dropActive) {
        this.hideDropdown();
      }
    },
    onSelectDropPress: function() {
      this.pressedFlag = true;
    },
    onSelectDropRelease: function(e, pointerEvent) {
      this.pressedFlag = false;
      if (pointerEvent.pointerType === 'mouse') {
        this.realElement.focus();
      }
    },
    onSelectAreaPress: function(e) {
      // skip click if drop inside fake element or real select is disabled
      var dropClickedInsideFakeElement = !this.options.fakeDropInBody && $(e.target).closest(this.dropdown).length;
      if (dropClickedInsideFakeElement || e.button > 1 || this.realElement.is(':disabled')) {
        return;
      }

      // toggle dropdown visibility
      this.selectOpenedByEvent = e.pointerType;
      this.toggleDropdown();

      // misc handlers
      if (!this.focusedFlag) {
        if (e.pointerType === 'mouse') {
          this.realElement.focus();
        } else {
          this.onFocus(e);
        }
      }
      this.pressedFlag = true;
      this.fakeElement.addClass(this.options.pressedClass);
      this.doc.on('jcf-pointerup', this.onSelectAreaRelease);
    },
    onSelectAreaRelease: function(e) {
      if (this.focusedFlag && e.pointerType === 'mouse') {
        this.realElement.focus();
      }
      this.pressedFlag = false;
      this.fakeElement.removeClass(this.options.pressedClass);
      this.doc.off('jcf-pointerup', this.onSelectAreaRelease);
    },
    onOutsideClick: function(e) {
      var target = $(e.target),
          clickedInsideSelect = target.closest(this.fakeElement).length || target.closest(this.dropdown).length;

      if (!clickedInsideSelect) {
        this.hideDropdown();
      }
    },
    onSelect: function() {
      this.refresh();

      if (this.realElement.prop('multiple')) {
        this.repositionDropdown();
      } else {
        this.hideDropdown();
      }

      this.fireNativeEvent(this.realElement, 'change');
    },
    toggleListMode: function(state) {
      if (!this.options.wrapNative) {
        if (state) {
          // temporary change select to list to avoid appearing of native dropdown
          this.realElement.attr({
            size: 4,
            'jcf-size': ''
          });
        } else {
          // restore select from list mode to dropdown select
          if (!this.options.wrapNative) {
            this.realElement.removeAttr('size jcf-size');
          }
        }
      }
    },
    createDropdown: function() {
      // destroy previous dropdown if needed
      if (this.dropdown) {
        this.list.destroy();
        this.dropdown.remove();
      }

      // create new drop container
      this.dropdown = $(this.options.fakeDropStructure).appendTo(this.fakeDropTarget);
      this.dropdown.addClass(getPrefixedClasses(this.realElement.prop('className'), this.options.selectClassPrefix));
      makeUnselectable(this.dropdown);

      // handle compact multiple style
      if (this.realElement.prop('multiple')) {
        this.dropdown.addClass('jcf-compact-multiple');
      }

      // set initial styles for dropdown in body
      if (this.options.fakeDropInBody) {
        this.dropdown.css({
          position: 'absolute',
          top: -9999
        });
      }

      // create new select list instance
      this.list = new SelectList({
        useHoverClass: true,
        handleResize: false,
        alwaysPreventMouseWheel: true,
        maxVisibleItems: this.options.maxVisibleItems,
        useCustomScroll: this.options.useCustomScroll,
        holder: this.dropdown.find(this.options.dropContentSelector),
        multipleSelectWithoutKey: this.realElement.prop('multiple'),
        element: this.realElement
      });
      $(this.list).on({
        select: this.onSelect,
        press: this.onSelectDropPress,
        release: this.onSelectDropRelease
      });
    },
    repositionDropdown: function() {
      var selectOffset = this.fakeElement.offset(),
          selectWidth = this.fakeElement.outerWidth(),
          selectHeight = this.fakeElement.outerHeight(),
          dropHeight = this.dropdown.css('width', selectWidth).outerHeight(),
          winScrollTop = this.win.scrollTop(),
          winHeight = this.win.height(),
          calcTop, calcLeft, bodyOffset, needFlipDrop = false;

      // check flip drop position
      if (selectOffset.top + selectHeight + dropHeight > winScrollTop + winHeight && selectOffset.top - dropHeight > winScrollTop) {
        needFlipDrop = true;
      }

      if (this.options.fakeDropInBody) {
        bodyOffset = this.fakeDropTarget.css('position') !== 'static' ? this.fakeDropTarget.offset().top : 0;
        if (this.options.flipDropToFit && needFlipDrop) {
          // calculate flipped dropdown position
          calcLeft = selectOffset.left;
          calcTop = selectOffset.top - dropHeight - bodyOffset;
        } else {
          // calculate default drop position
          calcLeft = selectOffset.left;
          calcTop = selectOffset.top + selectHeight - bodyOffset;
        }

        // update drop styles
        this.dropdown.css({
          width: selectWidth,
          left: calcLeft,
          top: calcTop
        });
      }

      // refresh flipped class
      this.dropdown.add(this.fakeElement).toggleClass(this.options.flipDropClass, this.options.flipDropToFit && needFlipDrop);
    },
    showDropdown: function() {
      // do not show empty custom dropdown
      if (!this.realElement.prop('options').length) {
        return;
      }

      // create options list if not created
      if (!this.dropdown) {
        this.createDropdown();
      }

      // show dropdown
      this.dropActive = true;
      this.dropdown.appendTo(this.fakeDropTarget);
      this.fakeElement.addClass(this.options.dropActiveClass);
      this.refreshSelectedText();
      this.repositionDropdown();
      this.list.setScrollTop(this.savedScrollTop);
      this.list.refresh();

      // add temporary event handlers
      this.win.on('resize', this.onResize);
      this.doc.on('jcf-pointerdown', this.onOutsideClick);
    },
    hideDropdown: function() {
      if (this.dropdown) {
        this.savedScrollTop = this.list.getScrollTop();
        this.fakeElement.removeClass(this.options.dropActiveClass + ' ' + this.options.flipDropClass);
        this.dropdown.removeClass(this.options.flipDropClass).detach();
        this.doc.off('jcf-pointerdown', this.onOutsideClick);
        this.win.off('resize', this.onResize);
        this.dropActive = false;
        if (this.selectOpenedByEvent === 'touch') {
          this.onBlur();
        }
      }
    },
    toggleDropdown: function() {
      if (this.dropActive) {
        this.hideDropdown();
      } else {
        this.showDropdown();
      }
    },
    refreshSelectedText: function() {
      // redraw selected area
      var selectedIndex = this.realElement.prop('selectedIndex'),
          selectedOption = this.realElement.prop('options')[selectedIndex],
          selectedOptionImage = selectedOption ? selectedOption.getAttribute('data-image') : null,
          selectedOptionText = '',
          selectedOptionClasses,
          self = this;

      if (this.realElement.prop('multiple')) {
        $.each(this.realElement.prop('options'), function(index, option) {
          if (option.selected) {
            selectedOptionText += (selectedOptionText ? ', ' : '') + option.innerHTML;
          }
        });
        if (!selectedOptionText) {
          selectedOptionText = self.realElement.attr('placeholder') || '';
        }
        this.selectText.removeAttr('class').html(selectedOptionText);
      } else if (!selectedOption) {
        if (this.selectImage) {
          this.selectImage.hide();
        }
        this.selectText.removeAttr('class').empty();
      } else if (this.currentSelectedText !== selectedOption.innerHTML || this.currentSelectedImage !== selectedOptionImage) {
        selectedOptionClasses = getPrefixedClasses(selectedOption.className, this.options.optionClassPrefix);
        this.selectText.attr('class', selectedOptionClasses).html(selectedOption.innerHTML);

        if (selectedOptionImage) {
          if (!this.selectImage) {
            this.selectImage = $('<img>').prependTo(this.selectTextContainer).hide();
          }
          this.selectImage.attr('src', selectedOptionImage).show();
        } else if (this.selectImage) {
          this.selectImage.hide();
        }

        this.currentSelectedText = selectedOption.innerHTML;
        this.currentSelectedImage = selectedOptionImage;
      }
    },
    refresh: function() {
      // refresh fake select visibility
      if (this.realElement.prop('style').display === 'none') {
        this.fakeElement.hide();
      } else {
        this.fakeElement.show();
      }

      // refresh selected text
      this.refreshSelectedText();

      // handle disabled state
      this.fakeElement.toggleClass(this.options.disabledClass, this.realElement.is(':disabled'));
    },
    destroy: function() {
      // restore structure
      if (this.options.wrapNative) {
        this.realElement.insertBefore(this.fakeElement).css({
          position: '',
          height: '',
          width: ''
        }).removeClass(this.options.resetAppearanceClass);
      } else {
        this.realElement.removeClass(this.options.hiddenClass);
        if (this.realElement.is('[jcf-size]')) {
          this.realElement.removeAttr('size jcf-size');
        }
      }

      // removing element will also remove its event handlers
      this.fakeElement.remove();

      // remove other event handlers
      this.doc.off('jcf-pointerup', this.onSelectAreaRelease);
      this.realElement.off({
        focus: this.onFocus
      });
    }
  });

  // listbox module
  function ListBox(options) {
    this.options = $.extend({
      wrapNative: true,
      useCustomScroll: true,
      fakeStructure: '<span class="jcf-list-box"><span class="jcf-list-wrapper"></span></span>',
      selectClassPrefix: 'jcf-select-',
      listHolder: '.jcf-list-wrapper'
    }, options);
    this.init();
  }
  $.extend(ListBox.prototype, {
    init: function() {
      this.bindHandlers();
      this.initStructure();
      this.attachEvents();
    },
    initStructure: function() {
      this.realElement = $(this.options.element);
      this.fakeElement = $(this.options.fakeStructure).insertAfter(this.realElement);
      this.listHolder = this.fakeElement.find(this.options.listHolder);
      makeUnselectable(this.fakeElement);

      // copy classes from original select
      this.fakeElement.addClass(getPrefixedClasses(this.realElement.prop('className'), this.options.selectClassPrefix));
      this.realElement.addClass(this.options.hiddenClass);

      this.list = new SelectList({
        useCustomScroll: this.options.useCustomScroll,
        holder: this.listHolder,
        selectOnClick: false,
        element: this.realElement
      });
    },
    attachEvents: function() {
      // delayed refresh handler
      var self = this;
      this.delayedRefresh = function(e) {
        if (e && e.which === 16) {
          // ignore SHIFT key
          return;
        } else {
          clearTimeout(self.refreshTimer);
          self.refreshTimer = setTimeout(function() {
            self.refresh();
            self.list.scrollToActiveOption();
          }, 1);
        }
      };

      // other event handlers
      this.realElement.on({
        focus: this.onFocus,
        click: this.delayedRefresh,
        keydown: this.delayedRefresh
      });

      // select list event handlers
      $(this.list).on({
        select: this.onSelect,
        press: this.onFakeOptionsPress,
        release: this.onFakeOptionsRelease
      });
    },
    onFakeOptionsPress: function(e, pointerEvent) {
      this.pressedFlag = true;
      if (pointerEvent.pointerType === 'mouse') {
        this.realElement.focus();
      }
    },
    onFakeOptionsRelease: function(e, pointerEvent) {
      this.pressedFlag = false;
      if (pointerEvent.pointerType === 'mouse') {
        this.realElement.focus();
      }
    },
    onSelect: function() {
      this.fireNativeEvent(this.realElement, 'change');
      this.fireNativeEvent(this.realElement, 'click');
    },
    onFocus: function() {
      if (!this.pressedFlag || !this.focusedFlag) {
        this.fakeElement.addClass(this.options.focusClass);
        this.realElement.on('blur', this.onBlur);
        this.focusedFlag = true;
      }
    },
    onBlur: function() {
      if (!this.pressedFlag) {
        this.fakeElement.removeClass(this.options.focusClass);
        this.realElement.off('blur', this.onBlur);
        this.focusedFlag = false;
      }
    },
    refresh: function() {
      this.fakeElement.toggleClass(this.options.disabledClass, this.realElement.is(':disabled'));
      this.list.refresh();
    },
    destroy: function() {
      this.list.destroy();
      this.realElement.insertBefore(this.fakeElement).removeClass(this.options.hiddenClass);
      this.fakeElement.remove();
    }
  });

  // options list module
  function SelectList(options) {
    this.options = $.extend({
      holder: null,
      maxVisibleItems: 10,
      selectOnClick: true,
      useHoverClass: false,
      useCustomScroll: false,
      handleResize: true,
      multipleSelectWithoutKey: false,
      alwaysPreventMouseWheel: false,
      indexAttribute: 'data-index',
      cloneClassPrefix: 'jcf-option-',
      containerStructure: '<span class="jcf-list"><span class="jcf-list-content"></span></span>',
      containerSelector: '.jcf-list-content',
      captionClass: 'jcf-optgroup-caption',
      disabledClass: 'jcf-disabled',
      optionClass: 'jcf-option',
      groupClass: 'jcf-optgroup',
      hoverClass: 'jcf-hover',
      selectedClass: 'jcf-selected',
      scrollClass: 'jcf-scroll-active'
    }, options);
    this.init();
  }
  $.extend(SelectList.prototype, {
    init: function() {
      this.initStructure();
      this.refreshSelectedClass();
      this.attachEvents();
    },
    initStructure: function() {
      this.element = $(this.options.element);
      this.indexSelector = '[' + this.options.indexAttribute + ']';
      this.container = $(this.options.containerStructure).appendTo(this.options.holder);
      this.listHolder = this.container.find(this.options.containerSelector);
      this.lastClickedIndex = this.element.prop('selectedIndex');
      this.rebuildList();
    },
    attachEvents: function() {
      this.bindHandlers();
      this.listHolder.on('jcf-pointerdown', this.indexSelector, this.onItemPress);
      this.listHolder.on('jcf-pointerdown', this.onPress);

      if (this.options.useHoverClass) {
        this.listHolder.on('jcf-pointerover', this.indexSelector, this.onHoverItem);
      }
    },
    onPress: function(e) {
      $(this).trigger('press', e);
      this.listHolder.on('jcf-pointerup', this.onRelease);
    },
    onRelease: function(e) {
      $(this).trigger('release', e);
      this.listHolder.off('jcf-pointerup', this.onRelease);
    },
    onHoverItem: function(e) {
      var hoverIndex = parseFloat(e.currentTarget.getAttribute(this.options.indexAttribute));
      this.fakeOptions.removeClass(this.options.hoverClass).eq(hoverIndex).addClass(this.options.hoverClass);
    },
    onItemPress: function(e) {
      if (e.pointerType === 'touch' || this.options.selectOnClick) {
        // select option after "click"
        this.tmpListOffsetTop = this.list.offset().top;
        this.listHolder.on('jcf-pointerup', this.indexSelector, this.onItemRelease);
      } else {
        // select option immediately
        this.onSelectItem(e);
      }
    },
    onItemRelease: function(e) {
      // remove event handlers and temporary data
      this.listHolder.off('jcf-pointerup', this.indexSelector, this.onItemRelease);

      // simulate item selection
      if (this.tmpListOffsetTop === this.list.offset().top) {
        this.listHolder.on('click', this.indexSelector, { savedPointerType: e.pointerType }, this.onSelectItem);
      }
      delete this.tmpListOffsetTop;
    },
    onSelectItem: function(e) {
      var clickedIndex = parseFloat(e.currentTarget.getAttribute(this.options.indexAttribute)),
          pointerType = e.data && e.data.savedPointerType || e.pointerType || 'mouse',
          range;

      // remove click event handler
      this.listHolder.off('click', this.indexSelector, this.onSelectItem);

      // ignore clicks on disabled options
      if (e.button > 1 || this.realOptions[clickedIndex].disabled) {
        return;
      }

      if (this.element.prop('multiple')) {
        if (e.metaKey || e.ctrlKey || pointerType === 'touch' || this.options.multipleSelectWithoutKey) {
          // if CTRL/CMD pressed or touch devices - toggle selected option
          this.realOptions[clickedIndex].selected = !this.realOptions[clickedIndex].selected;
        } else if (e.shiftKey) {
          // if SHIFT pressed - update selection
          range = [this.lastClickedIndex, clickedIndex].sort(function(a, b) {
            return a - b;
          });
          this.realOptions.each(function(index, option) {
            option.selected = (index >= range[0] && index <= range[1]);
          });
        } else {
          // set single selected index
          this.element.prop('selectedIndex', clickedIndex);
        }
      } else {
        this.element.prop('selectedIndex', clickedIndex);
      }

      // save last clicked option
      if (!e.shiftKey) {
        this.lastClickedIndex = clickedIndex;
      }

      // refresh classes
      this.refreshSelectedClass();

      // scroll to active item in desktop browsers
      if (pointerType === 'mouse') {
        this.scrollToActiveOption();
      }

      // make callback when item selected
      $(this).trigger('select');
    },
    rebuildList: function() {
      // rebuild options
      var self = this,
          rootElement = this.element[0];

      // recursively create fake options
      this.storedSelectHTML = rootElement.innerHTML;
      this.optionIndex = 0;
      this.list = $(this.createOptionsList(rootElement));
      this.listHolder.empty().append(this.list);
      this.realOptions = this.element.find('option');
      this.fakeOptions = this.list.find(this.indexSelector);
      this.fakeListItems = this.list.find('.' + this.options.captionClass + ',' + this.indexSelector);
      delete this.optionIndex;

      // detect max visible items
      var maxCount = this.options.maxVisibleItems,
          sizeValue = this.element.prop('size');
      if (sizeValue > 1 && !this.element.is('[jcf-size]')) {
        maxCount = sizeValue;
      }

      // handle scrollbar
      var needScrollBar = this.fakeOptions.length > maxCount;
      this.container.toggleClass(this.options.scrollClass, needScrollBar);
      if (needScrollBar) {
        // change max-height
        this.listHolder.css({
          maxHeight: this.getOverflowHeight(maxCount),
          overflow: 'auto'
        });

        if (this.options.useCustomScroll && jcf.modules.Scrollable) {
          // add custom scrollbar if specified in options
          jcf.replace(this.listHolder, 'Scrollable', {
            handleResize: this.options.handleResize,
            alwaysPreventMouseWheel: this.options.alwaysPreventMouseWheel
          });
          return;
        }
      }

      // disable edge wheel scrolling
      if (this.options.alwaysPreventMouseWheel) {
        this.preventWheelHandler = function(e) {
          var currentScrollTop = self.listHolder.scrollTop(),
              maxScrollTop = self.listHolder.prop('scrollHeight') - self.listHolder.innerHeight();

          // check edge cases
          if ((currentScrollTop <= 0 && e.deltaY < 0) || (currentScrollTop >= maxScrollTop && e.deltaY > 0)) {
            e.preventDefault();
          }
        };
        this.listHolder.on('jcf-mousewheel', this.preventWheelHandler);
      }
    },
    refreshSelectedClass: function() {
      var self = this,
          selectedItem,
          isMultiple = this.element.prop('multiple'),
          selectedIndex = this.element.prop('selectedIndex');

      if (isMultiple) {
        this.realOptions.each(function(index, option) {
          self.fakeOptions.eq(index).toggleClass(self.options.selectedClass, !!option.selected);
        });
      } else {
        this.fakeOptions.removeClass(this.options.selectedClass + ' ' + this.options.hoverClass);
        selectedItem = this.fakeOptions.eq(selectedIndex).addClass(this.options.selectedClass);
        if (this.options.useHoverClass) {
          selectedItem.addClass(this.options.hoverClass);
        }
      }
    },
    scrollToActiveOption: function() {
      // scroll to target option
      var targetOffset = this.getActiveOptionOffset();
      if (typeof targetOffset === 'number') {
        this.listHolder.prop('scrollTop', targetOffset);
      }
    },
    getSelectedIndexRange: function() {
      var firstSelected = -1, lastSelected = -1;
      this.realOptions.each(function(index, option) {
        if (option.selected) {
          if (firstSelected < 0) {
            firstSelected = index;
          }
          lastSelected = index;
        }
      });
      return [firstSelected, lastSelected];
    },
    getChangedSelectedIndex: function() {
      var selectedIndex = this.element.prop('selectedIndex'),
          targetIndex;

      if (this.element.prop('multiple')) {
        // multiple selects handling
        if (!this.previousRange) {
          this.previousRange = [selectedIndex, selectedIndex];
        }
        this.currentRange = this.getSelectedIndexRange();
        targetIndex = this.currentRange[this.currentRange[0] !== this.previousRange[0] ? 0 : 1];
        this.previousRange = this.currentRange;
        return targetIndex;
      } else {
        // single choice selects handling
        return selectedIndex;
      }
    },
    getActiveOptionOffset: function() {
      // calc values
      var dropHeight = this.listHolder.height(),
          dropScrollTop = this.listHolder.prop('scrollTop'),
          currentIndex = this.getChangedSelectedIndex(),
          fakeOption = this.fakeOptions.eq(currentIndex),
          fakeOptionOffset = fakeOption.offset().top - this.list.offset().top,
          fakeOptionHeight = fakeOption.innerHeight();

      // scroll list
      if (fakeOptionOffset + fakeOptionHeight >= dropScrollTop + dropHeight) {
        // scroll down (always scroll to option)
        return fakeOptionOffset - dropHeight + fakeOptionHeight;
      } else if (fakeOptionOffset < dropScrollTop) {
        // scroll up to option
        return fakeOptionOffset;
      }
    },
    getOverflowHeight: function(sizeValue) {
      var item = this.fakeListItems.eq(sizeValue - 1),
          listOffset = this.list.offset().top,
          itemOffset = item.offset().top,
          itemHeight = item.innerHeight();

      return itemOffset + itemHeight - listOffset;
    },
    getScrollTop: function() {
      return this.listHolder.scrollTop();
    },
    setScrollTop: function(value) {
      this.listHolder.scrollTop(value);
    },
    createOption: function(option) {
      var newOption = document.createElement('span');
      newOption.className = this.options.optionClass;
      newOption.innerHTML = option.innerHTML;
      newOption.setAttribute(this.options.indexAttribute, this.optionIndex++);

      var optionImage, optionImageSrc = option.getAttribute('data-image');
      if (optionImageSrc) {
        optionImage = document.createElement('img');
        optionImage.src = optionImageSrc;
        newOption.insertBefore(optionImage, newOption.childNodes[0]);
      }
      if (option.disabled) {
        newOption.className += ' ' + this.options.disabledClass;
      }
      if (option.className) {
        newOption.className += ' ' + getPrefixedClasses(option.className, this.options.cloneClassPrefix);
      }
      return newOption;
    },
    createOptGroup: function(optgroup) {
      var optGroupContainer = document.createElement('span'),
          optGroupName = optgroup.getAttribute('label'),
          optGroupCaption, optGroupList;

      // create caption
      optGroupCaption = document.createElement('span');
      optGroupCaption.className = this.options.captionClass;
      optGroupCaption.innerHTML = optGroupName;
      optGroupContainer.appendChild(optGroupCaption);

      // create list of options
      if (optgroup.children.length) {
        optGroupList = this.createOptionsList(optgroup);
        optGroupContainer.appendChild(optGroupList);
      }

      optGroupContainer.className = this.options.groupClass;
      return optGroupContainer;
    },
    createOptionContainer: function() {
      var optionContainer = document.createElement('li');
      return optionContainer;
    },
    createOptionsList: function(container) {
      var self = this,
          list = document.createElement('ul');

      $.each(container.children, function(index, currentNode) {
        var item = self.createOptionContainer(currentNode),
            newNode;

        switch (currentNode.tagName.toLowerCase()) {
          case 'option': newNode = self.createOption(currentNode); break;
          case 'optgroup': newNode = self.createOptGroup(currentNode); break;
        }
        list.appendChild(item).appendChild(newNode);
      });
      return list;
    },
    refresh: function() {
      // check for select innerHTML changes
      if (this.storedSelectHTML !== this.element.prop('innerHTML')) {
        this.rebuildList();
      }

      // refresh custom scrollbar
      var scrollInstance = jcf.getInstance(this.listHolder);
      if (scrollInstance) {
        scrollInstance.refresh();
      }

      // refresh selectes classes
      this.refreshSelectedClass();
    },
    destroy: function() {
      this.listHolder.off('jcf-mousewheel', this.preventWheelHandler);
      this.listHolder.off('jcf-pointerdown', this.indexSelector, this.onSelectItem);
      this.listHolder.off('jcf-pointerover', this.indexSelector, this.onHoverItem);
      this.listHolder.off('jcf-pointerdown', this.onPress);
    }
  });

  // helper functions
  var getPrefixedClasses = function(className, prefixToAdd) {
    return className ? className.replace(/[\s]*([\S]+)+[\s]*/gi, prefixToAdd + '$1 ') : '';
  };
  var makeUnselectable = (function() {
    var unselectableClass = jcf.getOptions().unselectableClass;
    function preventHandler(e) {
      e.preventDefault();
    }
    return function(node) {
      node.addClass(unselectableClass).on('selectstart', preventHandler);
    };
  }());

}(jQuery, this));
/*!
 * JavaScript Custom Forms : Number Module
 *
 * Copyright 2014-2015 PSD2HTML - http://psd2html.com/jcf
 * Released under the MIT license (LICENSE.txt)
 *
 * Version: 1.1.3
 */
;(function($) {

  'use strict';

  jcf.addModule({
    name: 'Number',
    selector: 'input[type="number"]',
    options: {
      realElementClass: 'jcf-real-element',
      fakeStructure: '<span class="jcf-number"><span class="jcf-btn-inc"></span><span class="jcf-btn-dec"></span></span>',
      btnIncSelector: '.jcf-btn-inc',
      btnDecSelector: '.jcf-btn-dec',
      pressInterval: 150
    },
    matchElement: function(element) {
      return element.is(this.selector);
    },
    init: function() {
      this.initStructure();
      this.attachEvents();
      this.refresh();
    },
    initStructure: function() {
      this.page = $('html');
      this.realElement = $(this.options.element).addClass(this.options.realElementClass);
      this.fakeElement = $(this.options.fakeStructure).addClass('jcf-number--'+this.realElement.attr('class').split(' ')[0]).insertBefore(this.realElement).prepend(this.realElement);
      this.btnDec = this.fakeElement.find(this.options.btnDecSelector);
      this.btnInc = this.fakeElement.find(this.options.btnIncSelector);

      // set initial values
      this.initialValue = parseFloat(this.realElement.val()) || 0;
      this.minValue = parseFloat(this.realElement.attr('min'));
      this.maxValue = parseFloat(this.realElement.attr('max'));
      this.stepValue = parseFloat(this.realElement.attr('step')) || 1;

      // check attribute values
      this.minValue = isNaN(this.minValue) ? -Infinity : this.minValue;
      this.maxValue = isNaN(this.maxValue) ? Infinity : this.maxValue;

      // handle range
      if (isFinite(this.maxValue)) {
        this.maxValue -= (this.maxValue - this.minValue) % this.stepValue;
      }
    },
    attachEvents: function() {
      this.realElement.on({
        focus: this.onFocus
      });
      this.btnDec.add(this.btnInc).on('jcf-pointerdown', this.onBtnPress);
    },
    onBtnPress: function(e) {
      var self = this,
          increment;

      if (!this.realElement.is(':disabled')) {
        increment = this.btnInc.is(e.currentTarget);

        self.step(increment);
        clearInterval(this.stepTimer);
        this.stepTimer = setInterval(function() {
          self.step(increment);
        }, this.options.pressInterval);

        this.page.on('jcf-pointerup', this.onBtnRelease);
      }
    },
    onBtnRelease: function() {
      clearInterval(this.stepTimer);
      this.page.off('jcf-pointerup', this.onBtnRelease);
    },
    onFocus: function() {
      this.fakeElement.addClass(this.options.focusClass);
      this.realElement.on({
        blur: this.onBlur,
        keydown: this.onKeyPress
      });
    },
    onBlur: function() {
      this.fakeElement.removeClass(this.options.focusClass);
      this.realElement.off({
        blur: this.onBlur,
        keydown: this.onKeyPress
      });
    },
    onKeyPress: function(e) {
      if (e.which === 38 || e.which === 40) {
        e.preventDefault();
        this.step(e.which === 38);
      }
    },
    step: function(increment) {
      var originalValue = parseFloat(this.realElement.val()),
          newValue = originalValue || 0,
          addValue = this.stepValue * (increment ? 1 : -1),
          edgeNumber = isFinite(this.minValue) ? this.minValue : this.initialValue - Math.abs(newValue * this.stepValue),
          diff = Math.abs(edgeNumber - newValue) % this.stepValue;

      // handle step diff
      if (diff) {
        if (increment) {
          newValue += addValue - diff;
        } else {
          newValue -= diff;
        }
      } else {
        newValue += addValue;
      }

      // handle min/max limits
      if (newValue < this.minValue) {
        newValue = this.minValue;
      } else if (newValue > this.maxValue) {
        newValue = this.maxValue;
      }

      // update value in real input if its changed
      if (newValue !== originalValue) {
        this.realElement.val(newValue).trigger('change');
        this.refresh();
      }
    },
    refresh: function() {
      var isDisabled = this.realElement.is(':disabled'),
          currentValue = parseFloat(this.realElement.val());

      // handle disabled state
      this.fakeElement.toggleClass(this.options.disabledClass, isDisabled);

      // refresh button classes
      this.btnDec.toggleClass(this.options.disabledClass, currentValue === this.minValue);
      this.btnInc.toggleClass(this.options.disabledClass, currentValue === this.maxValue);
    },
    destroy: function() {
      // restore original structure
      this.realElement.removeClass(this.options.realElementClass).insertBefore(this.fakeElement);
      this.fakeElement.remove();
      clearInterval(this.stepTimer);

      // remove event handlers
      this.page.off('jcf-pointerup', this.onBtnRelease);
      this.realElement.off({
        keydown: this.onKeyPress,
        focus: this.onFocus,
        blur: this.onBlur
      });
    }
  });

}(jQuery));
/*!
 * jQuery Cookie Plugin v1.4.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2006, 2014 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD (Register as an anonymous module)
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    // Node/CommonJS
    module.exports = factory(require('jquery'));
  } else {
    // Browser globals
    factory(jQuery);
  }
}(function ($) {

  var pluses = /\+/g;

  function encode(s) {
    return config.raw ? s : encodeURIComponent(s);
  }

  function decode(s) {
    return config.raw ? s : decodeURIComponent(s);
  }

  function stringifyCookieValue(value) {
    return encode(config.json ? JSON.stringify(value) : String(value));
  }

  function parseCookieValue(s) {
    if (s.indexOf('"') === 0) {
      // This is a quoted cookie as according to RFC2068, unescape...
      s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
    }

    try {
      // Replace server-side written pluses with spaces.
      // If we can't decode the cookie, ignore it, it's unusable.
      // If we can't parse the cookie, ignore it, it's unusable.
      s = decodeURIComponent(s.replace(pluses, ' '));
      return config.json ? JSON.parse(s) : s;
    } catch(e) {}
  }

  function read(s, converter) {
    var value = config.raw ? s : parseCookieValue(s);
    return $.isFunction(converter) ? converter(value) : value;
  }

  var config = $.cookie = function (key, value, options) {

    // Write

    if (arguments.length > 1 && !$.isFunction(value)) {
      options = $.extend({}, config.defaults, options);

      if (typeof options.expires === 'number') {
        var days = options.expires, t = options.expires = new Date();
        t.setMilliseconds(t.getMilliseconds() + days * 864e+5);
      }

      return (document.cookie = [
        encode(key), '=', stringifyCookieValue(value),
        options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
        options.path    ? '; path=' + options.path : '',
        options.domain  ? '; domain=' + options.domain : '',
        options.secure  ? '; secure' : ''
      ].join(''));
    }

    // Read

    var result = key ? undefined : {},
      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all. Also prevents odd result when
      // calling $.cookie().
      cookies = document.cookie ? document.cookie.split('; ') : [],
      i = 0,
      l = cookies.length;

    for (; i < l; i++) {
      var parts = cookies[i].split('='),
        name = decode(parts.shift()),
        cookie = parts.join('=');

      if (key === name) {
        // If second argument (value) is a function it's a converter...
        result = read(cookie, value);
        break;
      }

      // Prevent storing a cookie that we couldn't decode.
      if (!key && (cookie = read(cookie)) !== undefined) {
        result[name] = cookie;
      }
    }

    return result;
  };

  config.defaults = {};

  $.removeCookie = function (key, options) {
    // Must not alter options, thus extending a fresh object...
    $.cookie(key, '', $.extend({}, options, { expires: -1 }));
    return !$.cookie(key);
  };

}));

/*
 * jQuery form validation plugin
 */
;(function($) {

  'use strict';

  var FormValidation = (function() {
    var Validator = function($field, $fields) {
      this.$field = $field;
      this.$fields = $fields;
    };

    Validator.prototype = {
      reg: {
        email: '^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$',
        number: '^[0-9]+$'
      },

      checkField: function() {
        return {
          state: this.run(),
          $fields: this.$field.add(this.additionalFields)
        }
      },

      run: function() {
        var fieldType;

        switch (this.$field.get(0).tagName.toUpperCase()) {
          case 'SELECT':
            fieldType = 'select';
            break;

          case 'TEXTAREA':
            fieldType = 'text';
            break;

          default:
            fieldType = this.$field.data('type') || this.$field.attr('type');
        }

        var functionName = 'check_' + fieldType.replace(/-/g,'_');
        var state = true;

        if ($.isFunction(this[functionName])) {
          state = this[functionName]();

          if (state && this.$field.data('confirm')) {
            state = this.check_confirm();
          }
        }

        return state;
      },

      check_email: function() {
        var value = this.getValue();
        var required = this.$field.data('required');
        var requiredOrValue = required || value.length;

        if ((requiredOrValue && !this.check_regexp(value, this.reg.email))) {
          return false;
        }

        return requiredOrValue ? true : null;
      },

      check_number: function() {
        var value = this.getValue();
        var required = this.$field.data('required');
        var isNumber = this.check_regexp(value, this.reg.number);
        var requiredOrValue = required || value.length;

        if (requiredOrValue && !isNumber) {
          return false;
        }

        var min = this.$field.data('min');
        var max = this.$field.data('max');
        value = +value;

        if ((min && (value < min || !isNumber)) || (max && (value > max || !isNumber))) {
          return false;
        }

        return (requiredOrValue || min || max) ? true : null;
      },

      check_password: function() {
        return this.check_text();
      },

      check_text: function() {
        var value = this.getValue();
        var required = this.$field.data('required');

        if (this.$field.data('required') && !value.length) {
          return false;
        }

        var min = +this.$field.data('min');
        var max = +this.$field.data('max');

        if ((min && value.length < min) || (max && value.length > max)) {
          return false;
        }

        var regExp = this.$field.data('regexp');

        if (regExp && !this.check_regexp(value, regExp)) {
          return false;
        }

        return (required || min || max || regExp) ? true : null;
      },

      check_confirm: function() {
        var value = this.getValue();
        var $confirmFields = this.$fields.filter('[data-confirm="' + this.$field.data('confirm') + '"]');
        var confirmState = true;

        for (var i = $confirmFields.length - 1; i >= 0; i--) {
          if ($confirmFields.eq(i).val() !== value || !value.length) {
            confirmState = false;
            break;
          }
        }

        this.additionalFields = $confirmFields;

        return confirmState;
      },

      check_select: function() {
        var required = this.$field.data('required');

        if (required && this.$field.get(0).selectedIndex === 0) {
          return false;
        }

        return required ? true : null;
      },

      check_radio: function() {
        var $fields = this.$fields.filter('[name="' + this.$field.attr('name') + '"]');
        var required = this.$field.data('required');

        if (required && !$fields.filter(':checked').length) {
          return false;
        }

        this.additionalFields = $fields;

        return required ? true : null;
      },

      check_checkbox: function() {
        var required = this.$field.data('required');

        if (required && !this.$field.prop('checked')) {
          return false;
        }

        return required ? true : null;
      },

      check_at_least_one: function() {
        var $fields = this.$fields.filter('[data-name="' + this.$field.data('name') + '"]');

        if (!$fields.filter(':checked').length) {
          return false;
        }

        this.additionalFields = $fields;

        return true;
      },

      check_regexp: function(val, exp) {
        return new RegExp(exp).test(val);
      },

      getValue: function() {
        if (this.$field.data('trim')) {
          this.$field.val($.trim(this.$field.val()));
        }

        return this.$field.val();
      }
    };

    var publicClass = function(form, options) {
      this.$form = $(form).attr('novalidate', 'novalidate');
      this.options = options;
    };

    publicClass.prototype = {
      buildSelector: function(input) {
        return input + ':not(' + this.options.skipDefaultFields + (this.options.skipFields ? ',' + this.options.skipFields : '') + ')';
      },

      init: function() {
        this.fieldsSelector = this.buildSelector(':input');

        this.$form
        .on('submit', this.submitHandler.bind(this))
        .on('keyup blur', this.fieldsSelector, this.changeHandler.bind(this))
        .on('change', this.buildSelector('select'), this.changeHandler.bind(this))
        .on('focus', this.fieldsSelector, this.focusHandler.bind(this));
      },

      submitHandler: function(e) {
        var self = this;
        var $fields = this.getFormFields();

        this.getClassTarget($fields)
        .removeClass(this.options.errorClass + ' ' + this.options.successClass);

        this.setFormState(true);

        $fields.each(function(i, input) {
          var $field = $(input);
          var $classTarget = self.getClassTarget($field);

          // continue iteration if $field has error class already
          if ($classTarget.hasClass(self.options.errorClass)) {
            return;
          }

          self.setState(new Validator($field, $fields).checkField());
        });

        return this.checkSuccess($fields, e);
      },

      checkSuccess: function($fields, e) {
        var self = this;
        var success = this.getClassTarget($fields || this.getFormFields())
        .filter('.' + this.options.errorClass).length === 0;

        if (e && success && this.options.successSendClass) {
          e.preventDefault();

          $.ajax({
            url: this.$form.removeClass(this.options.successSendClass).attr('action') || '/',
            type: this.$form.attr('method') || 'POST',
            data: this.$form.serialize(),
            success: function() {
              self.$form.addClass(self.options.successSendClass);
            }
          });
        }

        this.setFormState(success);

        return success;
      },

      changeHandler: function(e) {
        var $field = $(e.target);

        if ($field.data('interactive')) {
          this.setState(new Validator($field, this.getFormFields()).checkField());
        }

        this.checkSuccess();
      },

      focusHandler: function(e) {
        var $field = $(e.target);

        this.getClassTarget($field)
        .removeClass(this.options.errorClass + ' ' + this.options.successClass);

        this.checkSuccess();
      },

      setState: function(result) {
        this.getClassTarget(result.$fields)
        .toggleClass(this.options.errorClass, result.state !== null && !result.state)
        .toggleClass(this.options.successClass, result.state !== null && this.options.successClass && !!result.state);
      },

      setFormState: function(state) {
        if (this.options.errorFormClass) {
          this.$form.toggleClass(this.options.errorFormClass, !state);
        }
      },

      getClassTarget: function($input) {
        return (this.options.addClassToParent ? $input.closest(this.options.addClassToParent) : $input);
      },

      getFormFields: function() {
        return this.$form.find(this.fieldsSelector);
      }
    };

    return publicClass;
  }());

  $.fn.formValidation = function(options) {
    options = $.extend({}, {
      errorClass: 'input-error',
      successClass: '',
      errorFormClass: '',
      addClassToParent: '',
      skipDefaultFields: ':button, :submit, :image, :hidden, :reset',
      skipFields: '',
      successSendClass: ''
    }, options);

    return this.each(function() {
      new FormValidation(this, options).init();
    });
  };
}(jQuery));
/*
 * jQuery video background plugin
*/
;(function($, $win) {
  var BgVideoController = (function() {
    var videos = [];

    return {
      init: function() {
        $win.on('load.bgVideo resize.bgVideo orientationchange.bgVideo', this.resizeHandler.bind(this));
      },

      resizeHandler: function() {
        if (this.isInit) {
          $.each(videos, this.resizeVideo.bind(this));
        }
      },

      buildPoster: function($video, $holder) {
        $holder.css({
          'background-image': 'url(' + $video.attr('poster') + ')',
          'background-repeat':'no-repeat',
          'background-size':'cover'
        });
      },

      resizeVideo: function(i) {
        var item = videos[i];
        var styles = this.getDimensions({
          videoRatio: item.ratio,
          maskWidth: item.$holder.outerWidth(),
          maskHeight: item.$holder.outerHeight()
        });

        item.$video.css({
          width: styles.width,
          height: styles.height,
          marginTop: styles.top,
          marginLeft: styles.left
        });
      },

      getRatio: function($video) {
        return $video[0].videoWidth / $video[0].videoHeight ||
            $video.attr('width') / $video.attr('height') ||
            $video.width() / $video.height();
      },

      getDimensions: function(data) {
        var ratio = data.videoRatio,
            slideWidth = data.maskWidth,
            slideHeight = slideWidth / ratio;

        if (slideHeight < data.maskHeight) {
          slideHeight = data.maskHeight;
          slideWidth = slideHeight * ratio;
        }
        return {
          width: slideWidth,
          height: slideHeight,
          top: (data.maskHeight - slideHeight) / 2,
          left: (data.maskWidth - slideWidth) / 2
        };
      },

      add: function($video, options) {
        var $holder = options.videoHolder ? $video.closest(options.videoHolder) : $video.parent();
        var item = {
          $video: $video,
          $holder: $holder,
          options: options
        };

        if ($video.attr('poster')) {
          this.buildPoster($video, $holder);
        }

        if ($video[0].readyState) {
          this.onVideoReady(item);
          if ($video[0].paused) {
            $video[0].play();
          } else {
            $holder.addClass(options.activeClass);
          }
        } else {
          $video.one('loadedmetadata', function() {
            if ($video[0].paused) {
              $video[0].play();
            } else {
              $holder.addClass(options.activeClass);
            }
            this.onVideoReady(item);
          }.bind(this));
        }

        $video.one('play', function() {
          $holder.addClass(options.activeClass);
          this.makeCallback.apply($.extend(true, {}, this, item), ['onPlay']);
        }.bind(this));


        this.makeCallback.apply($.extend(true, {}, this, item), ['onInit']);
        return this;
      },

      onVideoReady: function(item) {
        if (!this.isInit) {
          this.isInit = true;
          this.init();
        }
        videos.push($.extend(item, {
          ratio: this.getRatio(item.$video)
        }));
        this.resizeVideo(videos.length - 1);
      },

      destroy: function($video) {
        if (!$video) {
          videos = videos.filter(this.destroySingle);
        } else {
          videos = videos.filter(function(item) {
            var removeFlag = item.$video.is($video);

            removeFlag && this.destroySingle(item);

            return !removeFlag;
          }.bind(this));
        }

        if (!videos.length) {
          this.isInit = false;
          $win.off('.bgVideo');
        }
      },

      destroySingle: function(item) {
        item.$video.removeAttr('style').removeData('BackgroundVideo')[0].pause();
        item.$holder.removeClass(item.options.activeClass);
      },

      makeCallback: function(name) {
        if (typeof this.options[name] === 'function') {
          var args = Array.prototype.slice.call(arguments);
          args.shift();
          this.options[name].apply(this, args);
        }
      }
    };
  }());

  $.fn.backgroundVideo = function(opt) {
    var args = Array.prototype.slice.call(arguments);
    var method = args[0];
    var options = $.extend({
      activeClass: 'video-active',
      videoHolder: null
    }, opt);

    return this.each(function() {
      var $video = jQuery(this);
      var instance = $video.data('BackgroundVideo');

      if (typeof opt === 'object' || typeof opt === 'undefined') {
        $video.data('BackgroundVideo', BgVideoController.add($video, options));
      } else if (typeof method === 'string' && instance) {
        if (typeof instance[method] === 'function') {
          args.shift();
          instance[method].apply(instance, args);
        }
      }
    });
  };

  window.BgVideoController = BgVideoController;

  return BgVideoController;
}(jQuery, jQuery(window)));
/*
 * jQuery Open/Close plugin
 */
;(function($) {
  function OpenClose(options) {
    this.options = $.extend({
      addClassBeforeAnimation: true,
      hideOnClickOutside: false,
      activeClass: 'active',
      opener: '.opener',
      slider: '.slide',
      animSpeed: 400,
      effect: 'fade',
      event: 'click'
    }, options);
    this.init();
  }
  OpenClose.prototype = {
    init: function() {
      if (this.options.holder) {
        this.findElements();
        this.attachEvents();
        this.makeCallback('onInit', this);
      }
    },
    findElements: function() {
      this.holder = $(this.options.holder);
      this.opener = this.holder.find(this.options.opener);
      this.slider = this.holder.find(this.options.slider);
    },
    attachEvents: function() {
      // add handler
      var self = this;
      this.eventHandler = function(e) {
        e.preventDefault();
        if (self.slider.hasClass(slideHiddenClass)) {
          self.showSlide();
        } else {
          self.hideSlide();
        }
      };
      self.opener.on(self.options.event, this.eventHandler);

      // hover mode handler
      if (self.options.event === 'hover') {
        self.opener.on('mouseenter', function() {
          if (!self.holder.hasClass(self.options.activeClass)) {
            self.showSlide();
          }
        });
        self.holder.on('mouseleave', function() {
          self.hideSlide();
        });
      }

      // outside click handler
      self.outsideClickHandler = function(e) {
        if (self.options.hideOnClickOutside) {
          var target = $(e.target);
          if (!target.is(self.holder) && !target.closest(self.holder).length) {
            self.hideSlide();
          }
        }
      };

      // set initial styles
      if (this.holder.hasClass(this.options.activeClass)) {
        $(document).on('click touchstart', self.outsideClickHandler);
      } else {
        this.slider.addClass(slideHiddenClass);
      }
    },
    showSlide: function() {
      var self = this;
      if (self.options.addClassBeforeAnimation) {
        self.holder.addClass(self.options.activeClass);
      }
      self.slider.removeClass(slideHiddenClass);
      $(document).on('click touchstart', self.outsideClickHandler);

      self.makeCallback('animStart', true);
      toggleEffects[self.options.effect].show({
        box: self.slider,
        speed: self.options.animSpeed,
        complete: function() {
          if (!self.options.addClassBeforeAnimation) {
            self.holder.addClass(self.options.activeClass);
          }
          self.makeCallback('animEnd', true);
        }
      });
    },
    hideSlide: function() {
      var self = this;
      if (self.options.addClassBeforeAnimation) {
        self.holder.removeClass(self.options.activeClass);
      }
      $(document).off('click touchstart', self.outsideClickHandler);

      self.makeCallback('animStart', false);
      toggleEffects[self.options.effect].hide({
        box: self.slider,
        speed: self.options.animSpeed,
        complete: function() {
          if (!self.options.addClassBeforeAnimation) {
            self.holder.removeClass(self.options.activeClass);
          }
          self.slider.addClass(slideHiddenClass);
          self.makeCallback('animEnd', false);
        }
      });
    },
    destroy: function() {
      this.slider.removeClass(slideHiddenClass).css({
        display: ''
      });
      this.opener.off(this.options.event, this.eventHandler);
      this.holder.removeClass(this.options.activeClass).removeData('OpenClose');
      $(document).off('click touchstart', this.outsideClickHandler);
    },
    makeCallback: function(name) {
      if (typeof this.options[name] === 'function') {
        var args = Array.prototype.slice.call(arguments);
        args.shift();
        this.options[name].apply(this, args);
      }
    }
  };

  // add stylesheet for slide on DOMReady
  var slideHiddenClass = 'js-slide-hidden';
  (function() {
    var tabStyleSheet = $('<style type="text/css">')[0];
    var tabStyleRule = '.' + slideHiddenClass;
    tabStyleRule += '{position:absolute !important;left:-9999px !important;top:-9999px !important;display:block !important}';
    if (tabStyleSheet.styleSheet) {
      tabStyleSheet.styleSheet.cssText = tabStyleRule;
    } else {
      tabStyleSheet.appendChild(document.createTextNode(tabStyleRule));
    }
    $('head').append(tabStyleSheet);
  }());

  // animation effects
  var toggleEffects = {
    slide: {
      show: function(o) {
        o.box.stop(true).hide().slideDown(o.speed, o.complete);
      },
      hide: function(o) {
        o.box.stop(true).slideUp(o.speed, o.complete);
      }
    },
    fade: {
      show: function(o) {
        o.box.stop(true).hide().fadeIn(o.speed, o.complete);
      },
      hide: function(o) {
        o.box.stop(true).fadeOut(o.speed, o.complete);
      }
    },
    none: {
      show: function(o) {
        o.box.hide().show(0, o.complete);
      },
      hide: function(o) {
        o.box.hide(0, o.complete);
      }
    }
  };

  // jQuery plugin interface
  $.fn.openClose = function(opt) {
    var args = Array.prototype.slice.call(arguments);
    var method = args[0];

    return this.each(function() {
      var $holder = jQuery(this);
      var instance = $holder.data('OpenClose');

      if (typeof opt === 'object' || typeof opt === 'undefined') {
        $holder.data('OpenClose', new OpenClose($.extend({
          holder: this
        }, opt)));
      } else if (typeof method === 'string' && instance) {
        if (typeof instance[method] === 'function') {
          args.shift();
          instance[method].apply(instance, args);
        }
      }
    });
  };
}(jQuery));
/*
 * jQuery Accordion plugin new
 */
;(function(root, factory) {

  'use strict';
  if (typeof define === 'function' && define.amd) {
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    module.exports = factory(require('jquery'));
  } else {
    root.SlideAccordion = factory(jQuery);
  }
}(this, function($) {

  'use strict';
  var accHiddenClass = 'js-acc-hidden';

  function SlideAccordion(options) {
    this.options = $.extend(true, {
      allowClickWhenExpanded: false,
      activeClass:'active',
      opener:'.opener',
      slider:'.slide',
      animSpeed: 300,
      collapsible:true,
      event: 'click',
      scrollToActiveItem: {
        enable: false,
        breakpoint: 767, // max-width
        animSpeed: 600,
        extraOffset: null
      }
    }, options);
    this.init();
  }

  SlideAccordion.prototype = {
    init: function() {
      if (this.options.holder) {
        this.findElements();
        this.setStateOnInit();
        this.attachEvents();
        this.makeCallback('onInit');
      }
    },

    findElements: function() {
      this.$holder = $(this.options.holder).data('SlideAccordion', this);
      this.$items = this.$holder.find(':has(' + this.options.slider + ')');
    },

    setStateOnInit: function() {
      var self = this;

      this.$items.each(function() {
        if (!$(this).hasClass(self.options.activeClass)) {
          $(this).find(self.options.slider).addClass(accHiddenClass);
        }
      });
    },

    attachEvents: function() {
      var self = this;

      this.accordionToggle = function(e) {
        var $item = jQuery(this).closest(self.$items);
        var $actiItem = self.getActiveItem($item);

        if (!self.options.allowClickWhenExpanded || !$item.hasClass(self.options.activeClass)) {
          e.preventDefault();
          self.toggle($item, $actiItem);
        }
      };

      this.$items.on(this.options.event, this.options.opener, this.accordionToggle);
    },

    toggle: function($item, $prevItem) {
      if (!$item.hasClass(this.options.activeClass)) {
        this.show($item);
      } else if (this.options.collapsible) {
        this.hide($item);
      }

      if (!$item.is($prevItem) && $prevItem.length) {
        this.hide($prevItem);
      }

      this.makeCallback('beforeToggle');
    },

    show: function($item) {
      var $slider = $item.find(this.options.slider);

      $item.addClass(this.options.activeClass);
      $slider.stop().hide().removeClass(accHiddenClass).slideDown({
        duration: this.options.animSpeed,
        complete: function() {
          $slider.removeAttr('style');
          if (
              this.options.scrollToActiveItem.enable &&
              window.innerWidth <= this.options.scrollToActiveItem.breakpoint
          ) {
            this.goToItem($item);
          }
          this.makeCallback('onShow', $item);
        }.bind(this)
      });

      this.makeCallback('beforeShow', $item);
    },

    hide: function($item) {
      var $slider = $item.find(this.options.slider);

      $item.removeClass(this.options.activeClass);
      $slider.stop().show().slideUp({
        duration: this.options.animSpeed,
        complete: function() {
          $slider.addClass(accHiddenClass);
          $slider.removeAttr('style');
          this.makeCallback('onHide', $item);
        }.bind(this)
      });

      this.makeCallback('beforeHide', $item);
    },

    goToItem: function($item) {
      var itemOffset = $item.offset().top;

      if (itemOffset < $(window).scrollTop()) {
        // handle extra offset
        if (typeof this.options.scrollToActiveItem.extraOffset === 'number') {
          itemOffset -= this.options.scrollToActiveItem.extraOffset;
        } else if (typeof this.options.scrollToActiveItem.extraOffset === 'function') {
          itemOffset -= this.options.scrollToActiveItem.extraOffset();
        }

        $('body, html').animate({
          scrollTop: itemOffset
        }, this.options.scrollToActiveItem.animSpeed);
      }
    },

    getActiveItem: function($item) {
      return $item.siblings().filter('.' + this.options.activeClass);
    },

    makeCallback: function(name) {
      if (typeof this.options[name] === 'function') {
        var args = Array.prototype.slice.call(arguments);
        args.shift();
        this.options[name].apply(this, args);
      }
    },

    destroy: function() {
      this.$holder.removeData('SlideAccordion');
      this.$items.off(this.options.event, this.options.opener, this.accordionToggle);
      this.$items.removeClass(this.options.activeClass).each(function(i, item) {
        $(item).find(this.options.slider).removeAttr('style').removeClass(accHiddenClass);
      }.bind(this));
      this.makeCallback('onDestroy');
    }
  };

  $.fn.slideAccordion = function(opt) {
    var args = Array.prototype.slice.call(arguments);
    var method = args[0];

    return this.each(function() {
      var $holder = jQuery(this);
      var instance = $holder.data('SlideAccordion');

      if (typeof opt === 'object' || typeof opt === 'undefined') {
        new SlideAccordion($.extend(true, {
          holder: this
        }, opt));
      } else if (typeof method === 'string' && instance) {
        if(typeof instance[method] === 'function') {
          args.shift();
          instance[method].apply(instance, args);
        }
      }
    });
  };

  (function() {
    var tabStyleSheet = $('<style type="text/css">')[0];
    var tabStyleRule = '.' + accHiddenClass;
    tabStyleRule += '{position:absolute !important;left:-9999px !important;top:-9999px !important;display:block !important; width: 100% !important;}';
    if (tabStyleSheet.styleSheet) {
      tabStyleSheet.styleSheet.cssText = tabStyleRule;
    } else {
      tabStyleSheet.appendChild(document.createTextNode(tabStyleRule));
    }
    $('head').append(tabStyleSheet);
  }());

  return SlideAccordion;
}));

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink',
    passwordValidateFormSubmit: '[data-password-form-submit]',
    passwordField: '[data-password]',
    confirmPasswordField: '[data-confirm-password]'
  };

  $(config.passwordValidateFormSubmit).on('click', validatePasswordAction);

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  function validatePasswordAction(e) {
    let $passwordField = $(config.passwordField);
    let $confirmPasswordField = $(config.confirmPasswordField);

    if ($confirmPasswordField.length && $passwordField.val() !== '') {
      if ($passwordField.val() !== $confirmPasswordField.val()) {
        e.preventDefault();

        $passwordField.addClass('input-error');
        $confirmPasswordField.addClass('input-error');
      } else {
        $passwordField.removeClass('input-error');
        $confirmPasswordField.removeClass('input-error');
      }
    }
  }
})();

/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace collection
 */

theme.collectionTemplate = (function() {
  var config = {
    filterOpener: '[data-filters-opener],.boost-pfs-filter-close',
    filtersSidebar: '[data-filters-sidebar]',
    productsHolder: '[data-products-holder]',
    productsHolderClassWhenFiltersOpened: 'medium-up--three-quarters',
    bodyClass: 'boost-pfs-filter-tree-open-body',
  };

  $('body').on('click', config.filterOpener, function (e) {
    e.preventDefault();
    $(config.filterOpener).toggleClass('active');
    $('body').toggleClass(config.bodyClass);
    $(config.productsHolder).toggleClass(config.productsHolderClassWhenFiltersOpened);

    if ($(window).width() > 767) {
      if ($(config.filtersSidebar).is(':visible')) {
        $(config.filtersSidebar).hide();
      } else {
        $(config.filtersSidebar).show();
      }
    } else {
      $(config.filtersSidebar).show();
    }
  });


})();


$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register('header', theme.Header);
  sections.register('product', theme.Product);
  sections.register('cart', theme.Cart);
  sections.register('footer', theme.Footer);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // sections viewport
  $('.shopify-section').itemInViewport({});

  // remove left padding for "Review Tab"
  if($('.stamped-container ul.stamped-tabs li.active')) {
    $('.stamped-container ul.stamped-tabs li.active').attr('style', 'padding-left: 0 !important');
  }
  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // init jcf
  jcf.setOptions('Select', {
    wrapNative: false,
    wrapNativeOnMobile: false
  });
  jcf.replaceAll();

  // Switch swatches for product grid item
  let activeClass = 'swatches__color--chosen'

  $('body').on('click', '.swatches__color', function() {
    let $chosenSwatch = $(this);
    let $container = $chosenSwatch.closest('[data-product-item]');
    let $swatches = $container.find('.swatches__color');
    let $link = $container.find('[data-product-item-link]');
    let $image = $container.find('[data-product-item-image]');

    if ($chosenSwatch.hasClass(activeClass)) return;

    $swatches.removeClass(activeClass);
    $chosenSwatch.addClass(activeClass);

    $link.attr('href', $chosenSwatch.data('url'));
    if(typeof $image.attr('srcset') !== typeof undefined && $image.attr('srcset') !== false) {
      $image.attr('srcset', $chosenSwatch.data('img'))
    } else {
      $image.attr('src', $chosenSwatch.data('img'))
    }
  });

  // load more trigger

  $(document).on('click', '#more', function(e) {
  e.preventDefault();
  ScrollExecute();
});

});


  // load more function
  
  // Shortcircuit variable

  let triggered = false;

function ScrollExecute() {
  let moreButon = $('#more').last();
  let nextUrl = moreButon.find('a.btn_loadmore').attr("href");

  if (moreButon.length && nextUrl && !triggered) {
    triggered = true;

    $.ajax({
      url: nextUrl,
      type: 'GET',
      beforeSend: function() {
        moreButon.remove(); // Önceki Load More'u sil
      }
    })
    .done(function(data) {
      // Yeni içerikleri al ve ekle
      let newBlogs = $(data).find('.blogs').html();
      $('.blogs').append(newBlogs);

      // Yeni #more butonunu al
      let newMore = $(data).find('#more');
      if (newMore.length) {
        $('.blogs').after(newMore); // Sayfaya yeni butonu ekle
        triggered = false; // Yeniden çağrılabilir hale getir
      }
    });
  }
}


// !function(){"use strict";function o(o){var t=["MSIE ","Trident/","Edge/"];return new RegExp(t.join("|")).test(o)}function t(){function t(o,t){this.scrollLeft=o,this.scrollTop=t}function r(o){return.5*(1-Math.cos(Math.PI*o))}function i(o){if(null===o||"object"!=typeof o||void 0===o.behavior||"auto"===o.behavior||"instant"===o.behavior)return!0;if("object"==typeof o&&"smooth"===o.behavior)return!1;throw new TypeError("behavior member of ScrollOptions "+o.behavior+" is not a valid value for enumeration ScrollBehavior.")}function s(o,t){return"Y"===t?o.clientHeight+h<o.scrollHeight:"X"===t?o.clientWidth+h<o.scrollWidth:void 0}function c(o,t){var e=l.getComputedStyle(o,null)["overflow"+t];return"auto"===e||"scroll"===e}function n(o){var t=s(o,"Y")&&c(o,"Y"),l=s(o,"X")&&c(o,"X");return t||l}function f(o){var t;do{t=(o=o.parentNode)===e.body}while(!1===t&&!1===n(o));return t=null,o}function a(o){var t,e,i,s=(y()-o.startTime)/v;t=r(s=s>1?1:s),e=o.startX+(o.x-o.startX)*t,i=o.startY+(o.y-o.startY)*t,o.method.call(o.scrollable,e,i),e===o.x&&i===o.y||l.requestAnimationFrame(a.bind(l,o))}function p(o,r,i){var s,c,n,f,p=y();o===e.body?(s=l,c=l.scrollX||l.pageXOffset,n=l.scrollY||l.pageYOffset,f=u.scroll):(s=o,c=o.scrollLeft,n=o.scrollTop,f=t),a({scrollable:s,method:f,startTime:p,startX:c,startY:n,x:r,y:i})}if(!("scrollBehavior"in e.documentElement.style&&!0!==l.__forceSmoothScrollPolyfill__)){var d=l.HTMLElement||l.Element,v=468,h=o(l.navigator.userAgent)?1:0,u={scroll:l.scroll||l.scrollTo,scrollBy:l.scrollBy,elementScroll:d.prototype.scroll||t,scrollIntoView:d.prototype.scrollIntoView},y=l.performance&&l.performance.now?l.performance.now.bind(l.performance):Date.now;l.scroll=l.scrollTo=function(){void 0!==arguments[0]&&(!0!==i(arguments[0])?p.call(l,e.body,void 0!==arguments[0].left?~~arguments[0].left:l.scrollX||l.pageXOffset,void 0!==arguments[0].top?~~arguments[0].top:l.scrollY||l.pageYOffset):u.scroll.call(l,void 0!==arguments[0].left?arguments[0].left:"object"!=typeof arguments[0]?arguments[0]:l.scrollX||l.pageXOffset,void 0!==arguments[0].top?arguments[0].top:void 0!==arguments[1]?arguments[1]:l.scrollY||l.pageYOffset))},l.scrollBy=function(){void 0!==arguments[0]&&(i(arguments[0])?u.scrollBy.call(l,void 0!==arguments[0].left?arguments[0].left:"object"!=typeof arguments[0]?arguments[0]:0,void 0!==arguments[0].top?arguments[0].top:void 0!==arguments[1]?arguments[1]:0):p.call(l,e.body,~~arguments[0].left+(l.scrollX||l.pageXOffset),~~arguments[0].top+(l.scrollY||l.pageYOffset)))},d.prototype.scroll=d.prototype.scrollTo=function(){if(void 0!==arguments[0])if(!0!==i(arguments[0])){var o=arguments[0].left,t=arguments[0].top;p.call(this,this,void 0===o?this.scrollLeft:~~o,void 0===t?this.scrollTop:~~t)}else{if("number"==typeof arguments[0]&&void 0===arguments[1])throw new SyntaxError("Value couldn't be converted");u.elementScroll.call(this,void 0!==arguments[0].left?~~arguments[0].left:"object"!=typeof arguments[0]?~~arguments[0]:this.scrollLeft,void 0!==arguments[0].top?~~arguments[0].top:void 0!==arguments[1]?~~arguments[1]:this.scrollTop)}},d.prototype.scrollBy=function(){void 0!==arguments[0]&&(!0!==i(arguments[0])?this.scroll({left:~~arguments[0].left+this.scrollLeft,top:~~arguments[0].top+this.scrollTop,behavior:arguments[0].behavior}):u.elementScroll.call(this,void 0!==arguments[0].left?~~arguments[0].left+this.scrollLeft:~~arguments[0]+this.scrollLeft,void 0!==arguments[0].top?~~arguments[0].top+this.scrollTop:~~arguments[1]+this.scrollTop))},d.prototype.scrollIntoView=function(){if(!0!==i(arguments[0])){var o=f(this),t=o.getBoundingClientRect(),r=this.getBoundingClientRect();o!==e.body?(p.call(this,o,o.scrollLeft+r.left-t.left,o.scrollTop+r.top-t.top),"fixed"!==l.getComputedStyle(o).position&&l.scrollBy({left:t.left,top:t.top,behavior:"smooth"})):l.scrollBy({left:r.left,top:r.top,behavior:"smooth"})}else u.scrollIntoView.call(this,void 0===arguments[0]||arguments[0])}}}var l=window,e=document;"object"==typeof exports?module.exports={polyfill:t}:t()}();

document.addEventListener("DOMContentLoaded", function(){

  const createTabs = function () {
    const tabs = document.querySelectorAll(".tabs");
    const tab = document.querySelectorAll(".tab");
    const panel = document.querySelectorAll(".panel");

    function onTabClick(event) {
      // deactivate existing active tabs and panel
      for (let i = 0; i < tab.length; i++) {
        tab[i].classList.remove("active");
      }

      for (let i = 0; i < panel.length; i++) {
        panel[i].classList.remove("active");

      }
      // activate new tabs and panel
      event.target.classList.add('active');
      let classString = event.target.getAttribute('data-target');
      document.getElementById('panels').getElementsByClassName(classString)[0].classList.add("active");
      
    }

    for (let i = 0; i < tab.length; i++) {
      tab[i].addEventListener('click', onTabClick, false);
      window.scrollTo(0,0)

    }

  }


  const changePlaceholderForFaq = function () {
    const searchField = document.getElementById('s4com-q');

    if (searchField) {
      searchField.placeholder = 'Search';
    }
  };

  const changePositionTitle = function () {
    const title = document.getElementsByClassName('s4com-top-heading')[0];
    const faqContainer = document.getElementsByClassName('s4com-container')[0];

    if (title && faqContainer) {
      const copyTitle = document.getElementsByClassName('s4com-top-heading')[0];
      title.remove();
      faqContainer.prepend(copyTitle);
    }
  };

  // footer start loading collapsed

  const removeFirstLoadOpenClass = function () {
    const elementWithClass = document.querySelectorAll('.footer-nav__title')

    elementWithClass.forEach(elem => {
      if (elem.classList.contains('opened')) {
        elem.classList.remove('opened')
      }
    })
  }

  const removeTopEvent = function () {
    const titles = document.querySelectorAll('.s4com-help-center-exclude')

    if (titles) {
      titles.forEach(element => {
        element.onclick = null;
      })
    }
  };

  const createFaqSidebar = function () {
    const width = window.innerWidth;
    const titles = document.querySelectorAll('.s4com-sub-heading');
    let faqArea = document.getElementsByClassName('section-div ')[0];

    if (faqArea) {
      faqArea = faqArea.parentElement;
      faqArea.classList.add('sticky-div');

      if (width < 1024 && faqArea.classList.contains('sticky-div')) {
        faqArea.classList.remove('sticky-div');
      }
    }

    if (titles && faqArea) {
      const div = document.createElement('div');
      const divWithText = document.createElement('div');
      divWithText.classList.add('for-mobile-text');
      divWithText.innerText= 'Jump to Topic';
      div.classList.add('faq-sidebar');
      div.id = 'noble-gases';
      const ul = document.createElement('ul');
      ul.classList.add('faq-lists');
      ul.classList.add('drop');

      const selectedElement = document.createElement('span');

      titles.forEach(element => {
        const li = document.createElement('li');
        li.classList.add('faq-list-item');
        // li.classList.add('selected');
        const a = document.createElement('a');
        element.id = element.innerText;
        a.classList.add('anhore-link');
        a.href = '#' + element.innerText;
        a.appendChild(document.createTextNode(element.innerText));
        li.appendChild(a);
        ul.appendChild(li);
      });
      ul.appendChild(selectedElement);
      div.appendChild(ul);
      div.prepend(divWithText);
      faqArea.prepend(div);
    }
  };

  const addSelectedClass = function () {
    const lists = document.querySelectorAll(".faq-sidebar .faq-list-item:nth-child(1)");
    
    if (lists) {
      lists.forEach(function(c){
        c.classList.add("selected");
     });
    }
  }

  const smothScrollToAnchor = function () {

    const links = document.querySelectorAll("a.anhore-link");

    if (links) {
      for (const link of links) {
        link.addEventListener("click", clickHandler);
      }
  
      function clickHandler(e) {
        if ($(this).closest('.faq-sidebar').hasClass('active')) {
          e.preventDefault();
          let href = this.getAttribute("href");
          var name = href.replace(/[#]/g, "");
          let additionalOffset = $(window).width() <= 1024 ? -120 : 160;
          const offsetTop = document.getElementById(name).offsetTop + additionalOffset;
          scroll({
            top: offsetTop,
            behavior: "smooth"
          });
        }
      }
    }
  }

  changePlaceholderForFaq();
  changePositionTitle();
  removeTopEvent();
  createFaqSidebar();
  setTimeout(function () {
    smothScrollToAnchor();
    addSelectedClass();
  }, 100);
  // toggleClass();
  removeFirstLoadOpenClass();
});


//Dropdown select https://codepen.io/LydiaB/pen/GqKQRJ
function DropDown(el) {
  this.dd = el;
  this.placeholder = this.dd.children('span');
  this.opts = this.dd.find('ul.drop li');
  this.val = '';
  this.index = -1;
  this.initEvents();
}

DropDown.prototype = {
  initEvents: function () {
      var obj = this;
      obj.dd.on('click', function (e) {
        if ($(window).width() <= 1024) {
          e.preventDefault();
          e.stopPropagation();
          $(this).toggleClass('active');
        }
      });
      obj.opts.on('click', function () {
          var opt = $(this);
          obj.val = opt.text();
          obj.index = opt.index();
          obj.placeholder.text(obj.val);
          opt.siblings().removeClass('selected');
          opt.filter(':contains("' + obj.val + '")').addClass('selected');
      }).change();
  },
  getValue: function () {
      return this.val;
  },
  getIndex: function () {
      return this.index;
  }
};

$(function () {
  setTimeout(function () {
    // create new variable for each menu
    var dd1 = new DropDown($('#noble-gases'));
    // var dd2 = new DropDown($('#other-gases'));
    $(document).click(function () {
        // close menu on document click
        $('.faq-sidebar').removeClass('active');
    });
  },100);
});

function Tabs() {
  var bindAll = function() {
    var menuElements = document.querySelectorAll('[data-tab]');
    for(var i = 0; i < menuElements.length ; i++) {
      menuElements[i].addEventListener('click', change, false);
    }
  }

  var clear = function() {
    var menuElements = document.querySelectorAll('[data-tab]');
    for(var i = 0; i < menuElements.length ; i++) {
      menuElements[i].classList.remove('active');
      var id = menuElements[i].getAttribute('data-tab');
      document.getElementById(id).classList.remove('active');
    }
  }

  var change = function(e) {
    e.preventDefault();
    clear();
    e.target.classList.add('active');
    var id = e.currentTarget.getAttribute('data-tab');
    document.getElementById(id).classList.add('active');
  }
  bindAll();
}

var connectTabs = new Tabs();


jQuery(document).ready(function($){
  $('.mobile-sirv-holder').on('click',function(e){
    Sirv.instance('sirv').fullscreen();
    e.preventDefault();
  })
});